/* ================================
   theme.js — consolidated (no page transitions)
   ================================ */

/* ---------------------------------
   UTIL
   --------------------------------- */
   const __inEditor = () => typeof Shopify !== 'undefined' && Shopify.designMode;

   const SIDE_PANEL_FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
   let sidePanelFocusables = [];
   let sidePanelTrapHandler = null;
   let sidePanelCurrentTrigger = null;
   let sidePanelLastActiveElement = null;
   
   
   /* ---------------------------------
      FIRE SEARCH BUTTONS
      --------------------------------- */
   function bindFireSearch(scope = document) {
     scope.querySelectorAll('.fire-search').forEach(el => {
       if (el.dataset.bound === '1') return;
       el.dataset.bound = '1';
       el.addEventListener('click', () => {
         const panel = document.querySelector('#global-side-panel');
         const cart = document.querySelector('[data-panel="cart"]');
         const search = document.querySelector('[data-panel="search"]');
         panel?.classList.add('is-visible');
         if (cart) cart.style.display = 'none';
         if (search) search.style.display = 'block';
         setTimeout(() => document.querySelector('#SearchInput')?.focus(), 200);
       });
     });
   }
   
   if (!window.__SplineCartQuantityState) {
     window.__SplineCartQuantityState = (() => {
       const map = new Map();
       const listeners = new Set();
       let loaded = false;
       let loading = null;
 
       const keyFor = (variantId) => {
         if (variantId === null || variantId === undefined) return null;
         const num = Number(variantId);
         return Number.isFinite(num) ? String(num) : String(variantId);
       };
 
       const emit = () => {
         listeners.forEach((fn) => {
           try {
             fn();
           } catch (err) {
             console.error('Cart quantity listener failed', err);
           }
         });
       };
 
       const rebuildFromCart = (cart) => {
         map.clear();
         if (cart && Array.isArray(cart.items)) {
           cart.items.forEach((item) => {
             const key = keyFor(item?.variant_id ?? item?.id);
             const qty = Number(item?.quantity) || 0;
             if (!key || qty <= 0) return;
             map.set(key, (map.get(key) || 0) + qty);
           });
         }
         loaded = true;
         emit();
       };
 
       const refresh = () => {
         if (loading) return loading;
         loading = fetch('/cart.js', { headers: { Accept: 'application/json' } })
           .then((res) => {
             if (!res.ok) throw new Error('cart_fetch_failed');
             return res.json();
           })
           .then((cart) => { rebuildFromCart(cart); })
           .catch((err) => {
             console.error('Failed to load cart state', err);
             loaded = true;
           })
           .finally(() => {
             loading = null;
           });
         return loading;
       };
 
       const ensure = () => {
         if (loaded) return Promise.resolve();
         return refresh();
       };
 
       return {
         ensure,
         refresh,
         applyCart: rebuildFromCart,
         setLineQuantity: (variantId, quantity) => {
           const key = keyFor(variantId);
           if (!key) return;
           loaded = true;
           if (quantity > 0) {
             map.set(key, quantity);
           } else {
             map.delete(key);
           }
           emit();
         },
         adjustVariant: (variantId, delta) => {
           const key = keyFor(variantId);
           if (!key || !Number.isFinite(delta)) return;
           loaded = true;
           const next = (map.get(key) || 0) + delta;
           if (next > 0) {
             map.set(key, next);
           } else {
             map.delete(key);
           }
           emit();
         },
         getQuantity: (variantId) => {
           const key = keyFor(variantId);
           if (!key) return 0;
           return map.get(key) || 0;
         },
         onChange: (fn) => {
           if (typeof fn !== 'function') return () => {};
           listeners.add(fn);
           return () => listeners.delete(fn);
         },
       };
     })();
   }
 
   /* ---------------------------------
      ADD-TO-CART (AJAX + drawer)
      --------------------------------- */
   window.initAtc = function initAtc(root) {
     if (!root) return;
   
     const form = root.querySelector('form.atc__form');
     const variantIdInput = root.querySelector('[data-variant-id]');
    const addBtn = root.querySelector('[data-add-btn]');
    const addBtnText = root.querySelector('[data-add-btn-text]');
    const addBtnAddLabel = addBtn?.dataset?.addLabel;
    const addBtnSoldLabel = addBtn?.dataset?.soldLabel;
    const addBtnMaxedLabel = addBtn?.dataset?.maxedLabel;
    const defaultAddText = addBtnAddLabel || root.dataset.addText || addBtnText?.textContent?.trim() || 'Add to cart';
    const soldOutText = addBtnSoldLabel || root.dataset.outOfStockText || defaultAddText;
    const stockMaxedNoteText = root.dataset.stockMessageMaxed || addBtnMaxedLabel || root.dataset.maxedText || soldOutText;
    const stockSoldOutNoteText = root.dataset.stockMessageSold || soldOutText;
    const outOfStockPriceText = root.dataset.outOfStockPrice || soldOutText;
     const qtyInput = root.querySelector('.atc__qty-input');
     const minus = root.querySelector('[data-qty-minus]');
     const plus = root.querySelector('[data-qty-plus]');
     const productJsonEl = root.querySelector('[data-product-json]');
    const variantInventoryEl = root.querySelector('[data-variant-inventory]');
    const product = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;
    let variantInventory = null;
    if (variantInventoryEl) {
      try {
        variantInventory = JSON.parse(variantInventoryEl.textContent);
      } catch (err) {
        console.error('Failed to parse variant inventory payload', err);
      }
    }
    const cartState = window.__SplineCartQuantityState;
    cartState?.ensure?.();
    if (typeof root.__cartQtyListenerDetach === 'function') {
      root.__cartQtyListenerDetach();
    }
    root.__cartQtyListenerDetach = cartState?.onChange?.(() => {
      updateVariant();
      updateButtonTotal();
    });
     const sectionRoot = root.closest('section.simple-product') || root;
     const displayedPriceEls = sectionRoot.querySelectorAll('[data-price]');
     const displayedCompareEls = sectionRoot.querySelectorAll('[data-compare-price]');
     const displayedUnitEls = sectionRoot.querySelectorAll('[data-unit-price]');
     const sellingPlanInput = root.querySelector('[data-selling-plan-input]');
     const purchaseOptionRadios = root.querySelectorAll('input[name="purchase_option"]');
     const sellingPlanWrappers = root.querySelectorAll('[data-selling-plan-options]');
     const recipientToggle = root.querySelector('[data-recipient-toggle]');
     const recipientFields = root.querySelector('[data-recipient-fields]');
     const recipientSendEmail = root.querySelector('[data-recipient-send-email]');
    const priceEl = root.querySelector('[data-add-total]');
    const stockNoteEl = root.querySelector('[data-stock-remaining]');
    const feedbackEl = root.querySelector('[data-atc-feedback]');
    const successMessage = feedbackEl?.dataset.successMessage || '';
    const errorMessage = feedbackEl?.dataset.errorMessage || '';
   
     const moneyFormatEsc = root.dataset.moneyFormat || "${{amount}}";
     const shopCurrency = root.dataset.currency || "";
   
    let currentVariantMaxQty = Infinity;
    const variantLimitMeta = {
      limit: Infinity,
      isMaxed: false,
      isSoldOut: false,
      isUnavailable: false,
      isInventoryDepleted: false,
      cartQty: 0,
      availableAfterCart: Infinity,
      ruleRemaining: Infinity,
    };
   
    const clampQty = (n) => {
      const minQty = Number.isFinite(currentVariantMaxQty) && currentVariantMaxQty <= 0 ? 0 : 1;
      let parsed = parseInt(n ?? '', 10);
      if (!Number.isFinite(parsed)) parsed = minQty;
      let qty = Math.max(minQty, parsed);
      if (Number.isFinite(currentVariantMaxQty)) {
        qty = Math.min(qty, currentVariantMaxQty);
      }
      return qty;
    };
     const decodeEntities = (str) => { const el = document.createElement('textarea'); el.innerHTML = str; return el.value; };
     const moneyFormat = decodeEntities(moneyFormatEsc);
   
    function syncQtyControls() {
      if (!qtyInput) return;
      if (qtyInput.disabled) {
        if (minus) minus.disabled = true;
        if (plus) plus.disabled = true;
        return;
      }
      const value = clampQty(qtyInput.value);
      if (String(value) !== qtyInput.value) {
        qtyInput.value = String(value);
      }
      if (minus) minus.disabled = value <= 1;
      if (plus) plus.disabled = Number.isFinite(currentVariantMaxQty) && value >= currentVariantMaxQty;
    }

    const setQtyInteractivity = (enabled) => {
      if (!qtyInput) return;
      qtyInput.disabled = !enabled;
      if (enabled) {
        qtyInput.removeAttribute('aria-disabled');
        qtyInput.setAttribute('min', '1');
        if (Number(qtyInput.value) < 1) {
          qtyInput.value = '1';
        }
      } else {
        qtyInput.setAttribute('aria-disabled', 'true');
        qtyInput.setAttribute('min', '0');
        qtyInput.value = '0';
      }
      if (minus) minus.disabled = !enabled;
      if (plus) plus.disabled = !enabled;
    };
    const setStockNote = (message) => {
      if (!stockNoteEl) return;
      if (message) {
        stockNoteEl.textContent = message;
        stockNoteEl.removeAttribute('hidden');
      } else {
        stockNoteEl.textContent = '';
        stockNoteEl.setAttribute('hidden', 'hidden');
      }
    };
   
    const resolveVariantInventory = (variant) => {
      if (!variant) return {};
      const fromPayload = variantInventory && variantInventory[variant.id] ? variantInventory[variant.id] : null;
      const quantity = variant.inventory_quantity ?? fromPayload?.inventory_quantity;
      const policy = variant.inventory_policy ?? fromPayload?.inventory_policy;
      const incoming = variant.incoming ?? fromPayload?.incoming;
      const nextIncomingDate = variant.next_incoming_date ?? fromPayload?.next_incoming_date;
      return { quantity, policy, incoming, nextIncomingDate };
    };

    const getVariantStockState = (variant) => {
      if (!variant) {
        return {
          isSoldOut: true,
          isUnavailable: true,
          isInventoryDepleted: true,
          inventoryHasValue: false,
          rawInventory: 0,
          availableAfterCart: 0,
          cartQty: 0,
        };
      }
      const { quantity } = resolveVariantInventory(variant);
      const cartQty = cartState?.getQuantity?.(variant.id) || 0;
      const rawInventory = Number(quantity);
      const inventoryHasValue = Number.isFinite(rawInventory);
      const availableAfterCart = inventoryHasValue ? Math.max(0, rawInventory - cartQty) : Infinity;
      const isUnavailable = !variant.available;
      const isInventoryDepleted = inventoryHasValue && rawInventory <= 0;
      const isSoldOut = isUnavailable || isInventoryDepleted;
      return { isSoldOut, isUnavailable, isInventoryDepleted, inventoryHasValue, rawInventory, availableAfterCart, cartQty };
    };

    function setVariantQuantityLimit(variant, stockState) {
      variantLimitMeta.limit = Infinity;
      variantLimitMeta.isMaxed = false;
      variantLimitMeta.isSoldOut = false;
      variantLimitMeta.isUnavailable = false;
      variantLimitMeta.isInventoryDepleted = false;
      variantLimitMeta.cartQty = 0;
      variantLimitMeta.availableAfterCart = Infinity;
      variantLimitMeta.ruleRemaining = Infinity;

      if (!variant) {
        currentVariantMaxQty = Infinity;
        setQtyInteractivity(true);
        if (qtyInput) {
          qtyInput.removeAttribute('max');
          qtyInput.setAttribute('min', '1');
        }
        syncQtyControls();
        return;
      }

      const state = stockState || getVariantStockState(variant);
      variantLimitMeta.cartQty = Number(state.cartQty) || 0;
      variantLimitMeta.availableAfterCart = state.availableAfterCart;
      variantLimitMeta.isUnavailable = !!state.isUnavailable;
      variantLimitMeta.isInventoryDepleted = !!state.isInventoryDepleted;
      variantLimitMeta.isSoldOut = Boolean(state.isUnavailable || state.isInventoryDepleted);

      const inventoryHasValue = !!state.inventoryHasValue;
      const cartQty = variantLimitMeta.cartQty;

      const rawRuleMax = Number(variant.quantity_rule?.max);
      const ruleMax = rawRuleMax > 0 ? rawRuleMax : Infinity;
      const ruleRemaining = Number.isFinite(ruleMax) ? Math.max(0, ruleMax - cartQty) : Infinity;
      variantLimitMeta.ruleRemaining = ruleRemaining;

      if (variantLimitMeta.isSoldOut) {
        currentVariantMaxQty = 0;
        variantLimitMeta.limit = 0;
        variantLimitMeta.isMaxed = false;
        setQtyInteractivity(false);
        qtyInput?.setAttribute('max', '0');
        syncQtyControls();
        return;
      }

      let derivedMax = Infinity;

      if (inventoryHasValue) {
        derivedMax = Math.min(derivedMax, Math.max(0, state.availableAfterCart));
      }

      if (Number.isFinite(ruleRemaining)) {
        derivedMax = Number.isFinite(derivedMax) ? Math.min(derivedMax, ruleRemaining) : ruleRemaining;
      }

      if (!Number.isFinite(derivedMax)) {
        derivedMax = Infinity;
      }

      if (Number.isFinite(derivedMax) && derivedMax <= 0) {
        currentVariantMaxQty = 0;
        variantLimitMeta.limit = 0;
        variantLimitMeta.isMaxed = true;
        setQtyInteractivity(false);
        qtyInput?.setAttribute('max', '0');
        syncQtyControls();
        return;
      }

      setQtyInteractivity(true);

      if (Number.isFinite(derivedMax)) {
        currentVariantMaxQty = Math.max(1, Math.floor(derivedMax));
        variantLimitMeta.limit = currentVariantMaxQty;
        variantLimitMeta.isMaxed = false;
        qtyInput?.setAttribute('max', String(currentVariantMaxQty));
      } else {
        currentVariantMaxQty = Infinity;
        variantLimitMeta.limit = Infinity;
        variantLimitMeta.isMaxed = false;
        qtyInput?.removeAttribute('max');
      }

      syncQtyControls();
    }
   
     function formatMoneyHTML(cents, formatStr) {
       const value = Math.round(Number(cents) || 0);
       if (window.Shopify && typeof Shopify.formatMoney === 'function') {
         return Shopify.formatMoney(value, formatStr);
       }
       const fmt = formatStr || "${{amount}}";
       const amount = (value / 100);
       let out = fmt
         .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(amount).toString())
         .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.toFixed(2).replace('.', ','))
         .replace(/\{\{\s*amount\s*\}\}/g, amount.toFixed(2));
       try {
         if (!/\{\{.*\}\}/.test(fmt)) out = new Intl.NumberFormat(undefined, { style: 'currency', currency: shopCurrency || 'USD' }).format(amount);
       } catch { }
       return out;
     }
   
     const clearFeedback = () => {
       if (!feedbackEl) return;
       feedbackEl.textContent = '';
       feedbackEl.setAttribute('hidden', 'hidden');
       feedbackEl.classList.remove('is-error', 'is-success');
     };
   
     const showFeedback = (message, isError = false) => {
       if (!feedbackEl || !message) return;
       feedbackEl.textContent = message;
       feedbackEl.classList.toggle('is-error', isError);
       feedbackEl.classList.toggle('is-success', !isError);
       feedbackEl.removeAttribute('hidden');
     };
   
     const getSelectedOptions = () => {
       const selects = root.querySelectorAll('[data-option-index].atc__select');
       const radios = root.querySelectorAll('[data-option-index].atc__radio:checked');
       if (radios.length) {
         const byIdx = {};
         radios.forEach(r => { byIdx[r.dataset.optionIndex] = r.value; });
         return product.options.map((_, i) => byIdx[i]);
       }
       if (selects.length) {
         const arr = Array.from(selects).sort((a, b) => (+a.dataset.optionIndex) - (+b.dataset.optionIndex));
         return arr.map(s => s.value);
       }
       return [];
     };
   
    function updateDisplayedPrices(variant) {
      if (!variant) return;
      const priceHTML = formatMoneyHTML(variant.price, moneyFormat);
      const stockState = getVariantStockState(variant);
      const isAvailable = !stockState.isSoldOut;
   
       displayedPriceEls.forEach(el => {
         if (el) {
           if (isAvailable) {
             el.innerHTML = priceHTML;
             el.classList.remove('is-unavailable');
           } else {
             el.textContent = outOfStockPriceText;
             el.classList.add('is-unavailable');
           }
           el.removeAttribute('hidden');
         }
       });
   
       const showCompare = isAvailable && variant.compare_at_price && variant.compare_at_price > variant.price;
       displayedCompareEls.forEach(el => {
         if (!el) return;
         if (showCompare) {
           el.innerHTML = formatMoneyHTML(variant.compare_at_price, moneyFormat);
           el.removeAttribute('hidden');
         } else {
           el.setAttribute('hidden', 'hidden');
         }
       });
   
       displayedUnitEls.forEach(el => {
         if (!el) return;
         if (isAvailable && variant.unit_price_measurement) {
           const measurement = variant.unit_price_measurement;
           const referenceValue = measurement.reference_value;
           const referenceUnit = measurement.reference_unit;
           const unitHTML = `${formatMoneyHTML(variant.unit_price, moneyFormat)} / ${referenceValue} ${referenceUnit}`;
           el.innerHTML = unitHTML;
           el.removeAttribute('hidden');
         } else {
           el.setAttribute('hidden', 'hidden');
         }
       });
     }
   
     const sellingPlanGroups = (product && product.selling_plan_groups) ? product.selling_plan_groups.map(g => ({ ...g, id: String(g.id) })) : [];
     const sellingPlanGroupMap = {};
     sellingPlanGroups.forEach(group => { sellingPlanGroupMap[group.id] = group; });
   
     function updateGiftCardRecipientVisibility() {
       if (!recipientToggle || !recipientFields) return;
       if (recipientToggle.checked) {
         recipientFields.removeAttribute('hidden');
         recipientSendEmail?.removeAttribute('disabled');
       } else {
         recipientFields.setAttribute('hidden', 'hidden');
         recipientSendEmail?.setAttribute('disabled', 'disabled');
       }
     }
   
     function setSellingPlanValue(planId) {
       if (!sellingPlanInput) return;
       if (planId) {
         sellingPlanInput.disabled = false;
         sellingPlanInput.value = String(planId);
       } else {
         sellingPlanInput.disabled = true;
         sellingPlanInput.value = '';
       }
     }
   
     function showSellingPlanWrapper(groupId) {
       sellingPlanWrappers.forEach(wrapper => {
         const isActive = groupId && wrapper.dataset.sellingPlanOptions === String(groupId);
         if (isActive) {
           wrapper.removeAttribute('hidden');
           wrapper.querySelector('[data-selling-plan-select]')?.removeAttribute('disabled');
           wrapper.querySelector('[data-selling-plan-single]')?.removeAttribute('hidden');
         } else {
           wrapper.setAttribute('hidden', 'hidden');
           wrapper.querySelector('[data-selling-plan-select]')?.setAttribute('disabled', 'disabled');
           wrapper.querySelector('[data-selling-plan-single]')?.setAttribute('hidden', 'hidden');
         }
       });
     }
   
     function activatePurchaseOption(radio) {
       if (!radio || !purchaseOptionRadios.length) return;
       const optionType = radio.dataset.purchaseOption;
       if (optionType === 'one-time') {
         showSellingPlanWrapper(null);
         setSellingPlanValue(null);
         return;
       }
   
       const groupId = radio.dataset.groupId;
       if (!groupId) {
         setSellingPlanValue(null);
         return;
       }
   
       showSellingPlanWrapper(groupId);
       const wrapper = root.querySelector(`[data-selling-plan-options="${groupId}"]`);
       if (!wrapper) {
         setSellingPlanValue(null);
         return;
       }
       const select = wrapper.querySelector('[data-selling-plan-select]');
       if (select && !select.disabled) {
         const enabledOption = Array.from(select.options).find(opt => !opt.disabled);
         if (enabledOption) {
           select.value = enabledOption.value;
           setSellingPlanValue(enabledOption.value);
           return;
         }
       }
   
       const group = sellingPlanGroupMap[String(groupId)];
       const singlePlan = group && group.selling_plans && group.selling_plans.length ? group.selling_plans[0] : null;
       setSellingPlanValue(singlePlan ? singlePlan.id : null);
     }
   
     function updateSellingPlansForVariant(variant) {
       if (!sellingPlanInput || !product || !variant) return;
   
       const allocations = variant.selling_plan_allocations || [];
       const availablePlans = new Set(allocations.map(a => String(a.selling_plan_id)));
       const availableGroups = new Set(allocations.map(a => String(a.selling_plan_group_id)));
   
       purchaseOptionRadios.forEach(radio => {
         const groupId = radio.dataset.groupId;
         if (groupId) {
           const enabled = availableGroups.has(String(groupId));
           radio.disabled = !enabled;
           if (!enabled && radio.checked) radio.checked = false;
         }
       });
   
       sellingPlanWrappers.forEach(wrapper => {
         const groupId = wrapper.dataset.sellingPlanOptions;
         const select = wrapper.querySelector('[data-selling-plan-select]');
         const group = sellingPlanGroupMap[groupId];
         const isGroupAvailable = availableGroups.has(groupId);
         if (!isGroupAvailable) {
           wrapper.setAttribute('hidden', 'hidden');
           select?.setAttribute('disabled', 'disabled');
           wrapper.querySelector('[data-selling-plan-single]')?.setAttribute('hidden', 'hidden');
           return;
         }
   
         if (select) {
           let firstEnabled = null;
           Array.from(select.options).forEach(option => {
             const enabled = availablePlans.has(option.value);
             option.disabled = !enabled;
             if (enabled && !firstEnabled) firstEnabled = option;
           });
           if (firstEnabled) {
             if (select.disabled || select.value === '' || select.options[select.selectedIndex]?.disabled) {
               select.value = firstEnabled.value;
             }
             select.removeAttribute('disabled');
           } else {
             select.setAttribute('disabled', 'disabled');
           }
         } else if (group && group.selling_plans && group.selling_plans.length) {
           const planId = String(group.selling_plans[0].id);
           const singleIndicator = wrapper.querySelector('[data-selling-plan-single]');
           if (availablePlans.has(planId)) {
             singleIndicator?.removeAttribute('hidden');
           } else {
             singleIndicator?.setAttribute('hidden', 'hidden');
           }
         }
       });
   
       let activeRadio = Array.from(purchaseOptionRadios).find(r => r.checked && !r.disabled);
       if (!activeRadio) {
         activeRadio = Array.from(purchaseOptionRadios).find(r => r.dataset.purchaseOption === 'subscription' && !r.disabled)
           || Array.from(purchaseOptionRadios).find(r => r.dataset.purchaseOption === 'one-time' && !r.disabled);
         if (activeRadio) activeRadio.checked = true;
       }
   
       if (activeRadio) {
         activatePurchaseOption(activeRadio);
       } else {
         setSellingPlanValue(null);
       }
     }
   
     function updateLegendSelected() {
       if (!product) return;
       const selects = Array.from(root.querySelectorAll('[data-option-index].atc__select'));
       const radiosChecked = Array.from(root.querySelectorAll('[data-option-index].atc__radio:checked'));
       const byIdx = {};
       if (selects.length) selects.forEach(s => byIdx[+s.dataset.optionIndex] = s.value);
       if (radiosChecked.length) radiosChecked.forEach(r => byIdx[+r.dataset.optionIndex] = r.value);
       product.options.forEach((_, i) => {
         const el = root.querySelector(`.atc__legend-selected[data-selected-for="${i}"]`);
         if (el && byIdx[i] != null) el.textContent = byIdx[i];
       });
     }
   
     function findVariant(opts) {
       if (!product) return null;
       return product.variants.find(v => v.options.every((opt, i) => opt === opts[i]));
     }
   
     function updateButtonTotal() {
       if (!priceEl || !product) return;
       const opts = getSelectedOptions();
       const v = findVariant(opts) || product.selected_or_first_available_variant || product.variants?.[0];
       if (!v) { priceEl.innerHTML = ""; return; }
       const stockState = getVariantStockState(v);
      if (stockState.isSoldOut) { priceEl.innerHTML = ""; return; }
      const qty = qtyInput ? clampQty(qtyInput.value) : 1;
      if (qty <= 0) { priceEl.innerHTML = ""; return; }
      const totalCents = Math.round((Number(v.price) || 0) * qty);
      priceEl.innerHTML = formatMoneyHTML(totalCents, moneyFormat);
    }

    function updateVariant() {
      const opts = getSelectedOptions();
      const v = findVariant(opts);
      if (!v) return;
      if (variantIdInput) variantIdInput.value = v.id;
      const stockState = getVariantStockState(v);
      setVariantQuantityLimit(v, stockState);
      const isStockSoldOut = Boolean(stockState.isUnavailable || stockState.isInventoryDepleted);
      const isMaxedOut = Boolean(variantLimitMeta.isMaxed);
      const canPurchase = !(isStockSoldOut || isMaxedOut);
      if (addBtn) {
        addBtn.disabled = !canPurchase;
        addBtn.setAttribute('aria-disabled', String(!canPurchase));
        addBtn.classList.toggle('is-unavailable', !canPurchase);
      }
      if (addBtnText) {
        let btnLabel = defaultAddText;
        if (isStockSoldOut) {
          btnLabel = soldOutText;
        }
        addBtnText.textContent = btnLabel;
      }
      const noteMessage = isMaxedOut ? stockMaxedNoteText : (isStockSoldOut ? stockSoldOutNoteText : '');
      setStockNote(noteMessage);
      updateDisplayedPrices(v);
      updateSellingPlansForVariant(v);
      updateLegendSelected();
      updateButtonTotal();
      const eventDetail = { variant: v, product };
      root.dispatchEvent(new CustomEvent('variant:change', { detail: eventDetail }));
      document.dispatchEvent(new CustomEvent('variant:change', { detail: eventDetail }));
    }

     if (qtyInput) {
       const onQtyChanged = () => {
         qtyInput.value = String(clampQty(qtyInput.value));
         syncQtyControls();
         updateButtonTotal();
       };
       qtyInput.addEventListener('input', onQtyChanged);
       qtyInput.addEventListener('change', onQtyChanged);
     }
     if (minus && qtyInput) minus.addEventListener('click', () => {
       if (qtyInput.disabled) return;
       const current = clampQty(qtyInput.value);
       const next = Math.max(1, current - 1);
       if (next === current) return;
       qtyInput.value = String(next);
       qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
     });
     if (plus && qtyInput) plus.addEventListener('click', () => {
       if (qtyInput.disabled) return;
       const current = clampQty(qtyInput.value);
       const next = clampQty(current + 1);
       if (next === current) return;
       qtyInput.value = String(next);
       qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
     });
   
     if (recipientToggle) {
       updateGiftCardRecipientVisibility();
       recipientToggle.addEventListener('change', updateGiftCardRecipientVisibility);
     }
   
     root.addEventListener('change', (e) => {
       if (e.target.matches('[data-option-index]')) updateVariant();
       if (e.target.matches('input[name="purchase_option"]')) activatePurchaseOption(e.target);
       if (e.target.matches('[data-selling-plan-select]')) setSellingPlanValue(e.target.value);
     });
   
     // initialize displayed price with default variant
    const initialVariant = product?.selected_or_first_available_variant || product?.variants?.[0];
    if (initialVariant) {
      updateDisplayedPrices(initialVariant);
      updateSellingPlansForVariant(initialVariant);
      const initialStockState = getVariantStockState(initialVariant);
      setVariantQuantityLimit(initialVariant, initialStockState);
      const isStockSoldOut = Boolean(initialStockState.isUnavailable || initialStockState.isInventoryDepleted);
      const isMaxedOut = Boolean(variantLimitMeta.isMaxed);
      const canPurchaseInitial = !(isStockSoldOut || isMaxedOut);
      if (addBtn) {
        addBtn.disabled = !canPurchaseInitial;
        addBtn.setAttribute('aria-disabled', String(!canPurchaseInitial));
        addBtn.classList.toggle('is-unavailable', !canPurchaseInitial);
      }
      if (addBtnText) {
        let btnLabel = defaultAddText;
        if (isStockSoldOut) {
          btnLabel = soldOutText;
        }
        addBtnText.textContent = btnLabel;
      }
      const initialNote = isMaxedOut ? stockMaxedNoteText : (isStockSoldOut ? stockSoldOutNoteText : '');
      setStockNote(initialNote);
      updateButtonTotal();
    }
   
     if (form) {
       form.addEventListener('submit', async (ev) => {
         const sub = ev.submitter;
         if (sub && (sub.classList?.contains('shopify-payment-button__button') || sub.closest?.('.shopify-payment-button'))) {
           return; // accelerated checkout
         }
         ev.preventDefault();
         if (!variantIdInput?.value) return;
   
         clearFeedback();
         addBtn?.setAttribute('aria-busy', 'true');
         if (addBtn) addBtn.disabled = true;
         addBtnText?.setAttribute('aria-hidden', 'true');
   
         // Some apps redirect on onItemAdded — temporarily neutralize
         const prevOnItemAdded = window.Shopify?.onItemAdded;
         if (window.Shopify) window.Shopify.onItemAdded = () => { };
   
        let cartRefreshPromise = null;
        try {
          const fd = new FormData(form);
          const qty = qtyInput ? clampQty(qtyInput.value) : 1;
          fd.set('quantity', String(qty));

          const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd });
          if (!res.ok) throw new Error('add_failed');

          cartRefreshPromise = cartState?.refresh?.();

          const drawerRes = await fetch('/cart?view=drawer');
          const html = await drawerRes.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.getElementById('CartDrawerContents');
           const target = document.getElementById('CartDrawerContents');
           if (fresh && target) {
             target.innerHTML = fresh.innerHTML;
             if (typeof window.bindCartDrawerButtons === 'function') window.bindCartDrawerButtons();
           }
           if (typeof window.openSidePanel === 'function') window.openSidePanel('cart');
           if (successMessage) {
             showFeedback(successMessage, false);
           }
         } catch (e) {
           console.error('Cart error:', e);
           showFeedback(errorMessage || 'Unable to add to cart. Please try again.', true);
        } finally {
          if (window.Shopify) window.Shopify.onItemAdded = prevOnItemAdded;
          addBtn?.removeAttribute('aria-busy');
          if (addBtn) addBtn.disabled = false;
          addBtnText?.removeAttribute('aria-hidden');
          if (cartRefreshPromise && typeof cartRefreshPromise.then === 'function') {
            try {
              await cartRefreshPromise;
            } catch (err) {
              console.error('Cart refresh failed', err);
            }
          }
          updateVariant();
          updateButtonTotal();
        }
      });
    }
   
     updateVariant();
     updateLegendSelected();
     updateButtonTotal();
   };
   
   window.bindAtcIn = function bindAtcIn(container) {
     (container || document).querySelectorAll('[data-atc-root]').forEach(el => window.initAtc(el));
   };
   
   /* ---------------------------------
      LOCALIZATION FORM <localization-form>
      --------------------------------- */
   if (!customElements.get('localization-form')) {
     class LocalizationForm extends HTMLElement {
       constructor() {
         super();
         const wrapper = this.querySelector('.custom-localization-wrapper');
         const toggle = wrapper?.querySelector('.custom-localization-toggle') || this.querySelector('button');
         const inputs = Array.from(this.querySelectorAll('input[name="language_code"], input[name="country_code"]'));
        this.elements = {
          wrapper,
          button: toggle,
          panel: wrapper?.querySelector('.custom-localization-dropdown') || this.querySelector('ul'),
          inputs,
          input: inputs[0] || null,
        };
        this._skipClose = false;
        this._suppressToggle = false;
        this._prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this._panelTransitionHandler = null;
      }
   
       get items() {
         return Array.from(this.querySelectorAll('.dropdown-item'));
       }
   
       connectedCallback() {
         if (this.dataset.bound === '1') return;
         this.dataset.bound = '1';
   
         if (!this.elements.button || !this.elements.panel) return;
   
         this._onToggle = this.toggleSelector.bind(this);
         this._onClose = this.closeSelector.bind(this);
         this._onKeyUp = this.onContainerKeyUp.bind(this);
         this._onItemClick = this.onItemClick.bind(this);
         this._onPointerDown = this.onPointerDown.bind(this);
         this._onDocumentPointerDown = (event) => {
           if (!this.elements?.wrapper) return;
           const targetInside = this.contains(event.target);
           const isButton = this.elements.button && this.elements.button.contains(event.target);
   
           if (!targetInside) {
             this.hidePanel();
             return;
           }
   
           if (isButton && this.elements.wrapper.classList.contains('open')) {
             event.preventDefault();
             this._suppressToggle = true;
             this.hidePanel();
           }
         };
   
         this.elements.button.addEventListener('click', this._onToggle);
         this.elements.button.addEventListener('focusout', this._onClose);
         this.addEventListener('keyup', this._onKeyUp);
         this.addEventListener('focusout', this._onClose);
         this.addEventListener('pointerdown', this._onPointerDown);
         document.addEventListener('pointerdown', this._onDocumentPointerDown);
         this._boundItems = this.items;
         this._boundItems.forEach((item) => item.addEventListener('click', this._onItemClick));
       }
   
       disconnectedCallback() {
         if (!this.elements?.button) return;
         this.elements.button.removeEventListener('click', this._onToggle);
         this.elements.button.removeEventListener('focusout', this._onClose);
         this.removeEventListener('keyup', this._onKeyUp);
        this.removeEventListener('focusout', this._onClose);
        this.removeEventListener('pointerdown', this._onPointerDown);
        document.removeEventListener('pointerdown', this._onDocumentPointerDown);
        this._boundItems?.forEach((item) => item.removeEventListener('click', this._onItemClick));
        this._boundItems = [];
        if (this.elements?.panel && this._panelTransitionHandler) {
          this.elements.panel.removeEventListener('transitionend', this._panelTransitionHandler);
          this._panelTransitionHandler = null;
        }
        this.dataset.bound = '0';
      }
  
      hidePanel() {
        if (!this.elements?.button || !this.elements?.panel) return;
        if (this.elements.panel.hasAttribute('hidden')) return;
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.animatePanel(false);
        this.elements.wrapper?.classList.remove('open');
      }
   
       onContainerKeyUp(event) {
         if ((event.code || '').toUpperCase() !== 'ESCAPE') return;
         this.hidePanel();
         this.elements.button?.focus();
       }
   
       onItemClick(event) {
         event.preventDefault();
         const form = this.querySelector('form');
         const value = event.currentTarget?.dataset?.value;
         const targetName = event.currentTarget?.dataset?.input;
         if (value) {
           if (targetName) {
             const targetInput = (this.elements.inputs || []).find((input) => input.name === targetName);
             if (targetInput) targetInput.value = value;
           } else if (this.elements.input) {
             this.elements.input.value = value;
           }
         }
         this.hidePanel();
         if (form) form.submit();
       }
   
       toggleSelector(event) {
         event.preventDefault();
         if (!this.elements?.panel) return;
         if (this._suppressToggle) {
           this._suppressToggle = false;
           return;
         }
         this.elements.button?.focus();
         const isOpen = this.elements.wrapper?.classList.contains('open');
         if (isOpen) {
           this.hidePanel();
         } else {
           this.showPanel();
         }
       }

       showPanel() {
         if (!this.elements?.button || !this.elements?.panel) return;
         this.elements.button.setAttribute('aria-expanded', 'true');
         this.elements.wrapper?.classList.add('open');
         this.animatePanel(true);
         const [firstItem] = this.items;
         firstItem?.focus({ preventScroll: true });
       }

       closeSelector(event) {
         if (this._skipClose) return;
         if (!event) return;
         const nextTarget = event.relatedTarget;
         const focusInside = nextTarget && this.contains(nextTarget);
         if (!focusInside) {
           this.hidePanel();
         }
       }

       animatePanel(open) {
         const panel = this.elements?.panel;
         if (!panel) return;

         panel.removeEventListener('transitionend', this._panelTransitionHandler);
         this._panelTransitionHandler = null;

         if (open) {
           panel.removeAttribute('hidden');
         }

         panel.classList.add('is-animating');

         if (this._prefersReduced?.matches) {
           if (open) {
             panel.classList.add('is-open');
           } else {
             panel.classList.remove('is-open');
             panel.setAttribute('hidden', true);
           }
           panel.classList.remove('is-animating');
           panel.style.height = '';
           return;
         }

         if (open) {
           panel.classList.add('is-open');
           panel.style.height = 'auto';
           const targetHeight = panel.scrollHeight;
           panel.style.height = '0px';
           panel.offsetHeight; // force reflow
           panel.style.height = `${targetHeight}px`;
         } else {
           const currentHeight = panel.scrollHeight;
           panel.style.height = `${currentHeight}px`;
           panel.offsetHeight; // force reflow
           panel.classList.remove('is-open');
           panel.style.height = '0px';
         }

         this._panelTransitionHandler = (event) => {
           if (event.target !== panel || event.propertyName !== 'height') return;
           panel.classList.remove('is-animating');
           panel.style.height = '';
           if (!open) {
             panel.setAttribute('hidden', true);
             panel.classList.remove('is-open');
           }
           panel.removeEventListener('transitionend', this._panelTransitionHandler);
           this._panelTransitionHandler = null;
         };

         panel.addEventListener('transitionend', this._panelTransitionHandler);
       }

       onPointerDown(event) {
         if (!event) return;
         this._skipClose = true;
         requestAnimationFrame(() => {
           this._skipClose = false;
         });
       }
     }
     customElements.define('localization-form', LocalizationForm);
   }
   
   function initShareContainers(scope = document) {
     scope.querySelectorAll('.sp-share').forEach((wrap) => {
       if (wrap.dataset.bound === '1') return;
       wrap.dataset.bound = '1';
   
       const btn = wrap.querySelector('.native-share-trigger');
       const menu = wrap.querySelector('.share-fallback');
       const copyBtn = wrap.querySelector('.copy-link');
       const toast = wrap.querySelector('.share-toast');
   
       if (!menu) return;
   
       // Never hide the whole UL (trigger lives inside)
       menu.removeAttribute('hidden');
   
       const data = {
         title: wrap.dataset.shareTitle || document.title,
         text: wrap.dataset.shareText || document.title,
         url: wrap.dataset.shareUrl || window.location.href,
       };
       const iconsAlways = wrap.dataset.iconsAlways === 'true';
   
       const triggerItem = btn ? btn.closest('li') : null;
       const items = Array.from(menu.children);
       const nonTriggerItems = items.filter((li) => li !== triggerItem);
   
       function setMenu(open) {
         if (iconsAlways) return;
         nonTriggerItems.forEach((li) => { li.hidden = !open; });
         if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
         wrap.dataset.open = open ? 'true' : 'false';
       }
   
       // Initial collapsed state (unless icons must always show)
       if (!iconsAlways) setMenu(false);
   
       btn?.addEventListener('click', async () => {
         if (navigator.share) {
           try { await navigator.share(data); return; } catch (_) { }
         }
         const anyShown = nonTriggerItems.some((li) => !li.hidden);
         setMenu(!anyShown);
       });
   
       copyBtn?.addEventListener('click', async () => {
         try {
           await navigator.clipboard.writeText(data.url);
           if (toast) {
             toast.hidden = false;
             toast.textContent = wrap.dataset.copiedLabel || 'Link copied';
             setTimeout(() => (toast.hidden = true), 1400);
           }
         } catch {
           window.prompt(wrap.dataset.copyLabel || 'Copy link', data.url);
         }
       });
   
       document.addEventListener('click', (e) => {
         if (!wrap.contains(e.target)) setMenu(false);
       });
       wrap.addEventListener('keydown', (e) => {
         if (e.key === 'Escape') setMenu(false);
       });
     });
   }
   
   // Make sure it runs:
   document.addEventListener('DOMContentLoaded', () => initShareContainers());
   document.addEventListener('shopify:section:load', (e) => initShareContainers(e.target));
document.addEventListener('shopify:block:select', (e) => initShareContainers(e.target));

function computeSliderStep(list, itemSelector) {
  const items = Array.from(list.querySelectorAll(itemSelector));
  if (!items.length) return list.clientWidth || 1;

  const firstRect = items[0].getBoundingClientRect();

  for (let i = 1; i < items.length; i += 1) {
    const rect = items[i].getBoundingClientRect();
    const diff = Math.abs(rect.left - firstRect.left);
    if (diff > 1) return diff;
  }

  const styles = window.getComputedStyle(list);
  const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
  return firstRect.width + gap;
}

function setupProductGridBlock(root) {
  if (!root || root.dataset.pgBound === '1') return;

  const list = root.querySelector('.pg-grid');
  if (!list) return;

  const prev = root.querySelector('.pg-nav__prev');
  const next = root.querySelector('.pg-nav__next');
  const nav = root.querySelector('.pg-nav');
  const dotsWrap = root.querySelector('.pg-dots');
  const dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll('.pg-dots__btn')) : [];

  root.dataset.pgBound = '1';

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  const canScroll = () => (list.scrollWidth - list.clientWidth) > 2;
  const maxLeft = () => Math.max(0, list.scrollWidth - list.clientWidth);
  const getStepSize = () => computeSliderStep(list, '.pg-grid__item');

  const updateDots = () => {
       if (!dots.length) return;
       const overflow = canScroll();
       if (dotsWrap) dotsWrap.classList.toggle('is-hidden', !overflow);
       if (!overflow) return;

       const step = getStepSize() || 1;
       const rawIndex = Math.round(list.scrollLeft / step);
       const index = Math.max(0, Math.min(rawIndex, dots.length - 1));

       dots.forEach((btn, idx) => {
         const isActive = idx === index;
         btn.classList.toggle('is-active', isActive);
         btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
       });
     };

     const updateNavState = () => {
       if (!nav || !prev || !next) return;
       const overflow = canScroll();
       nav.classList.toggle('is-hidden', !overflow);
       if (!overflow) {
         prev.disabled = true;
         next.disabled = true;
         return;
       }
       prev.disabled = list.scrollLeft <= 1;
       next.disabled = list.scrollLeft >= (maxLeft() - 1);
     };

     const updateControls = () => {
       updateNavState();
       updateDots();
     };

     const page = (direction) => {
       const amount = getStepSize() || list.clientWidth;
       const target = Math.max(0, Math.min(list.scrollLeft + direction * amount, maxLeft()));
       list.scrollTo({
         left: target,
         behavior: prefersReduced.matches ? 'auto' : 'smooth'
       });
     };

     const goToIndex = (index) => {
       const safeIndex = Math.max(0, Math.min(index, dots.length - 1));
       const amount = getStepSize() || list.clientWidth;
       const target = Math.max(0, Math.min(safeIndex * amount, maxLeft()));
       list.scrollTo({
         left: target,
         behavior: prefersReduced.matches ? 'auto' : 'smooth'
       });
     };

     if (prev && next) {
       prev.addEventListener('click', () => page(-1));
       next.addEventListener('click', () => page(1));
     }

     if (dots.length) {
       dots.forEach((btn, idx) => {
         btn.addEventListener('click', () => goToIndex(idx));
       });
     }
   
     list.addEventListener('scroll', updateControls, { passive: true });
   
     if (root._pgResizeObserver) {
       root._pgResizeObserver.disconnect();
       root._pgResizeObserver = null;
     }
     if (root._pgResizeHandler) {
       window.removeEventListener('resize', root._pgResizeHandler);
       root._pgResizeHandler = null;
     }
   
     if ('ResizeObserver' in window) {
       const observer = new ResizeObserver(updateControls);
       observer.observe(list);
       root._pgResizeObserver = observer;
     } else {
       const resizeHandler = () => updateControls();
       window.addEventListener('resize', resizeHandler);
       root._pgResizeHandler = resizeHandler;
     }
   
     updateControls();
   }
   
function setupArticleGridBlock(root) {
  if (!root || root.dataset.agBound === '1') return;

  const list = root.querySelector('.ag-grid');
  if (!list) return;

  const prev = root.querySelector('.ag-nav__prev');
  const next = root.querySelector('.ag-nav__next');
  const nav = root.querySelector('.ag-nav');

  root.dataset.agBound = '1';

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const canScroll = () => (list.scrollWidth - list.clientWidth) > 2;
  const maxLeft = () => Math.max(0, list.scrollWidth - list.clientWidth);
  const getStepSize = () => computeSliderStep(list, '.ag-grid__item');

  const updateNavState = () => {
    if (!nav || !prev || !next) return;
    const overflow = canScroll();
    nav.classList.toggle('is-hidden', !overflow);
    if (!overflow) {
      prev.disabled = true;
      next.disabled = true;
      return;
    }
    prev.disabled = list.scrollLeft <= 1;
    next.disabled = list.scrollLeft >= (maxLeft() - 1);
  };

  const scrollByStep = (direction) => {
    const amount = getStepSize() || list.clientWidth;
    const target = Math.max(0, Math.min(list.scrollLeft + direction * amount, maxLeft()));
    list.scrollTo({
      left: target,
      behavior: prefersReduced.matches ? 'auto' : 'smooth'
    });
  };

  if (prev && next) {
    prev.addEventListener('click', () => scrollByStep(-1));
    next.addEventListener('click', () => scrollByStep(1));
  }

  list.addEventListener('scroll', updateNavState, { passive: true });

  if (root._agResizeObserver) {
    root._agResizeObserver.disconnect();
    root._agResizeObserver = null;
  }
  if (root._agResizeHandler) {
    window.removeEventListener('resize', root._agResizeHandler);
    root._agResizeHandler = null;
  }

  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(updateNavState);
    observer.observe(list);
    root._agResizeObserver = observer;
  } else {
    const resizeHandler = () => updateNavState();
    window.addEventListener('resize', resizeHandler);
    root._agResizeHandler = resizeHandler;
  }

  updateNavState();
}

function initProductGrids(scope = document) {
  scope.querySelectorAll('.product-grid-block').forEach((root) => setupProductGridBlock(root));
}

function initArticleGrids(scope = document) {
  scope.querySelectorAll('.article-grid-block').forEach((root) => setupArticleGridBlock(root));
}
   
   class ProductRecommendationsElement extends HTMLElement {
     connectedCallback() {
       if (this.dataset.prBound === '1') return;
       this.dataset.prBound = '1';
       this.loadRecommendations();
     }
   
     loadRecommendations() {
       const url = this.dataset.url;
       if (!url) return;
   
       fetch(url, { credentials: 'same-origin' })
         .then((response) => {
           if (!response.ok) throw new Error(`Failed to load recommendations: ${response.status}`);
           return response.text();
         })
         .then((html) => {
           const doc = new DOMParser().parseFromString(html, 'text/html');
           const selector = this.id
             ? `#${typeof CSS !== 'undefined' && typeof CSS.escape === 'function' ? CSS.escape(this.id) : this.id.replace(/([^\w-])/g, '\\$1')}`
             : null;
           const replacement = (selector ? doc.querySelector(selector) : null) || doc.querySelector('product-recommendations');
   
           if (!replacement) return;
   
           this.innerHTML = replacement.innerHTML;
           this.dataset.loaded = 'true';
   
           initProductGrids(this);
           initArticleGrids(this);
           this.dispatchEvent(new Event('load'));
           document.dispatchEvent(new CustomEvent('product-recommendations:updated', {
             bubbles: true,
             detail: { root: this }
           }));
         })
         .catch(() => {
           this.dataset.error = 'true';
         });
     }
   }
   
   if (!customElements.get('product-recommendations')) {
     customElements.define('product-recommendations', ProductRecommendationsElement);
   }
   
   /* Complementary products (per section) */
   function initComplementaryBlocks(scope = document) {
     scope.querySelectorAll('[data-complementary-load]').forEach((blockWrap) => {
       if (blockWrap.dataset.bound === '1') return;
       blockWrap.dataset.bound = '1';
   
       const shell = blockWrap.querySelector('.sp-complementary');
       const root = blockWrap.querySelector('[data-complementary-root]');
       if (!root || !shell) return;
   
       const updateVisibility = () => {
         const hasAny = !!root.querySelector('.pg-grid__item:not(.pg-grid__item--empty)');
         if (hasAny) {
           shell.removeAttribute('hidden');
         } else {
           shell.setAttribute('hidden', 'true');
         }
       };
   
      initProductGrids(shell);
      initArticleGrids(shell);
      updateVisibility();
   
       const url = new URL(blockWrap.dataset.recommendationsUrl, window.location.origin);
       url.searchParams.set('section_id', blockWrap.dataset.sectionId || '');
       url.searchParams.set('product_id', blockWrap.dataset.productId || '');
       url.searchParams.set('intent', 'complementary');
       url.searchParams.set('limit', blockWrap.dataset.limit || '8');
   
       fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
         .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
         .then((html) => {
           const doc = new DOMParser().parseFromString(html, 'text/html');
           const updated = doc.querySelector('[data-complementary-root]');
           if (!updated) return;
          root.innerHTML = updated.innerHTML;
          initProductGrids(shell);
          initArticleGrids(shell);
          updateVisibility();
         })
         .catch(() => {});
     });
   }
   
   /* Hashtag copy (buttons with [data-copy]) */
   function bindHashtagCopy(scope = document) {
     scope.querySelectorAll('[data-copy]').forEach((btn) => {
       if (btn.dataset.bound === '1') return;
       btn.dataset.bound = '1';
       btn.addEventListener('click', async () => {
         const val = btn.getAttribute('data-copy');
         try {
           await navigator.clipboard.writeText(val);
           const prev = btn.textContent;
           btn.textContent = btn.dataset.copied || 'Copied';
           setTimeout(() => btn.textContent = prev, 1200);
         } catch { }
       });
     });
   }
   
   function bindProductAccordions(scope = document) {
     const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
     scope.querySelectorAll('[data-accordion]').forEach((details) => {
       if (details.dataset.bound === '1') return;
       details.dataset.bound = '1';
   
       const summary = details.querySelector('summary');
       const panel = details.querySelector('[data-accordion-panel]');
       if (!summary || !panel) return;
   
       const COOLDOWN_MS = 140;
       let cooling = false;
   
       function lock(on) {
         details.classList.toggle('is-animating', on);
         summary.setAttribute('aria-disabled', on ? 'true' : 'false');
       }
       function afterAnim(cb) {
         cb(); cooling = true; setTimeout(() => { cooling = false; }, COOLDOWN_MS);
       }
       function resetHeight(el) { el.style.height = ''; }
   
       summary.addEventListener('click', (e) => {
         if (!reduceMotion.matches) e.preventDefault();          // we drive the toggle
         if (details.classList.contains('is-animating') || cooling) return;
         toggle();
       });
   
       details.addEventListener('toggle', () => {
         if (details.classList.contains('is-animating')) return; // ignore synthetic toggles
         resetHeight(details);
       });
   
       function animateHeight(el, from, to, done) {
         el.style.height = from + 'px';
         void el.offsetHeight;                                   // reflow
         el.style.height = to + 'px';
         const onEnd = (evt) => {
           if (evt.propertyName !== 'height') return;
           el.removeEventListener('transitionend', onEnd);
           done();
         };
         el.addEventListener('transitionend', onEnd);
       }
   
       function toggle() {
         if (reduceMotion.matches) {
           const willOpen = !details.open;
           details.classList.toggle('is-open', willOpen);
           details.open = willOpen;
           resetHeight(details);
           afterAnim(() => { });
           return;
         }
         lock(true);
         const start = details.offsetHeight;
         const summaryH = summary.offsetHeight;
   
         if (!details.open) {
           details.classList.add('is-open');
           details.open = true;                                  // make content measurable
           const end = summaryH + panel.scrollHeight;            // ← smoother & accurate
           animateHeight(details, start, end, () => {
             afterAnim(() => { details.style.height = ''; lock(false); });
           });
         } else {
           details.classList.remove('is-open');
           const end = summaryH;
           animateHeight(details, start, end, () => {
             details.open = false;                                // close after animation
             afterAnim(() => { details.style.height = ''; lock(false); });
           });
         }
       }
     });
   }
   
   /* Make stacked/grid media swipeable on mobile */
   function bindMobileSwipeMedia(scope = document) {
     const mq = window.matchMedia('(max-width: 770px)');
     const stacked = scope.querySelector('.sp-stacked');
     const grid = scope.querySelector('.sp-grid');
     if (!stacked && !grid) return;
   
     function mobileify(container) {
       if (!container) return;
       container.style.display = 'flex';
       container.style.gap = '0.5rem';
       container.style.overflowX = 'auto';
       container.style.scrollSnapType = 'x mandatory';
       container.querySelectorAll(':scope > *').forEach((cell) => {
         cell.style.flex = '0 0 85%';
         cell.style.scrollSnapAlign = 'start';
       });
     }
   
     function apply() {
       if (mq.matches) {
         mobileify(stacked);
         mobileify(grid);
       } else {
         [stacked, grid].forEach(w => {
           if (!w) return;
           w.style.display = ''; w.style.gap = ''; w.style.overflowX = ''; w.style.scrollSnapType = '';
           w.querySelectorAll(':scope > *').forEach(c => { c.style.flex = ''; c.style.scrollSnapAlign = ''; });
         });
       }
     }
   
     apply();
     mq.addEventListener?.('change', apply);
   }
   
   /* ---------------------------------
      Generic horizontal slider nav
      - Works for Showcase Collection + Tabbed Collections
      - Shows only valid arrow(s) based on scroll position
      - Aria-friendly: toggles aria-disabled & aria-hidden
   ---------------------------------- */
   
   (function () {
     const SELECTORS = [
       '.showcase-collection__wrapper.is-slider',
       '.tabbed-collections .tc-panel .showcase-collection__wrapper.is-slider'
     ];
   
     const getDir = (el) => (document.documentElement.dir === 'rtl' || getComputedStyle(el).direction === 'rtl') ? -1 : 1;
   
     function updateButtons(wrapper) {
       const grid = wrapper.querySelector('.showcase-collection__grid');
       const prevBtn = wrapper.querySelector('.slider-nav.prev');
       const nextBtn = wrapper.querySelector('.slider-nav.next');
       if (!grid || !prevBtn || !nextBtn) return;
   
       const maxScroll = grid.scrollWidth - grid.clientWidth;
       const x = grid.scrollLeft;
       // tolerate sub-pixel
       const atStart = x <= 1;
       const atEnd = x >= (maxScroll - 1);
   
       const setBtn = (btn, visible, disabled) => {
         btn.classList.toggle('is-visible', visible);
         btn.setAttribute('aria-hidden', String(!visible));
         btn.setAttribute('aria-disabled', String(!!disabled));
         btn.toggleAttribute('disabled', !!disabled);
       };
   
       // Show only right at start, only left at end, both in middle
       setBtn(prevBtn, !atStart || atEnd, atStart);
       setBtn(nextBtn, !atEnd || atStart, atEnd);
     }
   
     function pageScroll(grid) {
       // Scroll by a "page" (viewport width minus a small gap to hint continuity)
       const page = grid.clientWidth * 0.9;
       return Math.max(120, Math.round(page));
     }
   
     function bindWrapper(wrapper) {
       if (!wrapper || wrapper.dataset.navBound === '1') return;
       wrapper.dataset.navBound = '1';
   
       const grid = wrapper.querySelector('.showcase-collection__grid');
       const prevBtn = wrapper.querySelector('.slider-nav.prev');
       const nextBtn = wrapper.querySelector('.slider-nav.next');
       if (!grid || !prevBtn || !nextBtn) return;
   
       const dir = getDir(grid);
       const smoothOK = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
   
       const scrollByAmount = (delta) => {
         const amount = dir * delta;
         grid.scrollBy({ left: amount, behavior: smoothOK ? 'smooth' : 'auto' });
       };
   
       prevBtn.addEventListener('click', () => scrollByAmount(-pageScroll(grid)));
       nextBtn.addEventListener('click', () => scrollByAmount(pageScroll(grid)));
   
       // Keep buttons in sync while scrolling or resizing
       let raf = null;
       const sync = () => {
         if (raf) return;
         raf = requestAnimationFrame(() => {
           updateButtons(wrapper);
           raf = null;
         });
       };
       grid.addEventListener('scroll', sync, { passive: true });
       window.addEventListener('resize', sync);
       // Initial state
       updateButtons(wrapper);
     }
   
     function bindAll() {
       SELECTORS.forEach(sel => {
         document.querySelectorAll(sel).forEach(bindWrapper);
       });
     }
   
     // Initial + on theme editor section load
     document.addEventListener('DOMContentLoaded', bindAll);
     // In case sections are dynamically rendered/swapped
     document.addEventListener('shopify:section:load', bindAll);
     document.addEventListener('shopify:section:select', bindAll);
   
     // For Tabbed Collections: when panels toggle [hidden], refresh button states
     const tabbedRoot = document.querySelector('.tabbed-collections');
     if (tabbedRoot && 'MutationObserver' in window) {
       const mo = new MutationObserver((muts) => {
         for (const m of muts) {
           if (m.type === 'attributes' && m.attributeName === 'hidden') {
             const panel = m.target;
             if (!panel.hasAttribute('hidden')) {
               // rebind wrappers inside this panel and update immediately
               panel.querySelectorAll('.showcase-collection__wrapper.is-slider').forEach(w => {
                 bindWrapper(w);
                 updateButtons(w);
               });
             }
           }
         }
       });
       mo.observe(tabbedRoot, { attributes: true, subtree: true, attributeFilter: ['hidden'] });
     }
   })();
   
   /* ---------------------------------
      SHOWCASE COLLECTION (slider/nav)
      --------------------------------- */
   (function () {
     const SELECTOR = '.showcase-collection__wrapper.is-slider';
   
     function bindWrapper(wrapper) {
       if (!wrapper || wrapper.dataset.bound === '1') return;
       wrapper.dataset.bound = '1';
   
       const grid = wrapper.querySelector('.showcase-collection__grid');
       const prevBtn = wrapper.querySelector('.slider-nav.prev');
       const nextBtn = wrapper.querySelector('.slider-nav.next');
   
       if (!grid || !prevBtn || !nextBtn) return;
   
       const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
       let raf;
   
       const getPage = () => grid.clientWidth;
   
       const setBtnState = (btn, { visible, disabled }) => {
         btn.classList.toggle('is-visible', visible);
         btn.setAttribute('aria-hidden', String(!visible));
         btn.setAttribute('aria-disabled', String(disabled));
         btn.disabled = !!disabled;
         if (!visible || disabled) btn.setAttribute('tabindex', '-1');
         else btn.removeAttribute('tabindex');
       };
   
       const update = () => {
         const scrollLeft = Math.round(grid.scrollLeft);
         const max = grid.scrollWidth - grid.clientWidth;
   
         if (scrollLeft <= 0) {
           setBtnState(prevBtn, { visible: false, disabled: true });
           setBtnState(nextBtn, { visible: true, disabled: false });
         } else if (scrollLeft >= max - 1) {
           setBtnState(prevBtn, { visible: true, disabled: false });
           setBtnState(nextBtn, { visible: false, disabled: true });
         } else {
           setBtnState(prevBtn, { visible: true, disabled: false });
           setBtnState(nextBtn, { visible: true, disabled: false });
         }
       };
   
       const onPrev = () => grid.scrollBy({ left: -getPage(), behavior: prefersReduced ? 'auto' : 'smooth' });
       const onNext = () => grid.scrollBy({ left: getPage(), behavior: prefersReduced ? 'auto' : 'smooth' });
       const onScroll = () => { if (raf) cancelAnimationFrame(raf); raf = requestAnimationFrame(update); };
       const onResize = update;
   
       prevBtn.addEventListener('click', onPrev);
       nextBtn.addEventListener('click', onNext);
       grid.addEventListener('scroll', onScroll, { passive: true });
       window.addEventListener('resize', onResize, { passive: true });
   
       wrapper.__showcase_unbind__ = () => {
         prevBtn.removeEventListener('click', onPrev);
         nextBtn.removeEventListener('click', onNext);
         grid.removeEventListener('scroll', onScroll);
         window.removeEventListener('resize', onResize);
         delete wrapper.dataset.bound;
         delete wrapper.__showcase_unbind__;
       };
   
       update();
     }
   
     function bindAll(root) {
       (root || document).querySelectorAll(SELECTOR).forEach(bindWrapper);
     }
   
     document.addEventListener('DOMContentLoaded', () => bindAll(document));
   
     // Re-bind on Shopify editor loads
     document.addEventListener('shopify:section:load', e => bindAll(e.target));
     document.addEventListener('shopify:section:unload', e => {
       e.target?.querySelectorAll(SELECTOR).forEach(w => w.__showcase_unbind__ && w.__showcase_unbind__());
     });
   
     // When a tab panel becomes visible, re-evaluate arrows
     document.addEventListener('panel:shown', e => bindAll(e.target));
   })();
   
   /* ---------------------------------
      Collapsed Tabs / Split FAQs — accordion controller
      --------------------------------- */
   (function () {
     const SELECTOR = '.collapsed-tab, .faq-split'; // 👈 supports both
   
     function bindSplitFaqs(root) {
       const el = root;
       if (!el || el.dataset.faqBound === '1') return;
       el.dataset.faqBound = '1';
   
       const items = el.querySelectorAll('.fs-item');
       const singleOpen = (el.dataset.singleOpen || 'false') === 'true';
       const openFirst = (el.dataset.openFirst || 'false') === 'true';
       const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
   
       function onTransitionEndOnce(node, prop, cb) {
         const h = (e) => {
           if (e.target === node && e.propertyName === prop) {
             node.removeEventListener('transitionend', h);
             cb && cb();
           }
         };
         node.addEventListener('transitionend', h);
       }
   
       function closeItem(item) {
         return new Promise((resolve) => {
           const btn = item.querySelector('.fs-trigger');
           const panel = item.querySelector('.fs-panel');
           if (!btn || !panel) return resolve();
   
           if (btn.getAttribute('aria-expanded') === 'false') return resolve();
           btn.setAttribute('aria-expanded', 'false');
   
           if (prefersReduced) {
             panel.classList.remove('is-open');
             panel.style.maxHeight = null;
             panel.hidden = true;
             return resolve();
           }
   
           const current = panel.scrollHeight;
           panel.style.maxHeight = current + 'px';
           panel.offsetHeight; // reflow
           panel.classList.remove('is-open');
           panel.style.maxHeight = '0px';
   
           onTransitionEndOnce(panel, 'max-height', () => {
             panel.hidden = true;
             panel.style.maxHeight = null;
             resolve();
           });
         });
       }
   
       function openItem(item) {
         return new Promise((resolve) => {
           const btn = item.querySelector('.fs-trigger');
           const panel = item.querySelector('.fs-panel');
           if (!btn || !panel) return resolve();
   
           if (btn.getAttribute('aria-expanded') === 'true') return resolve();
           btn.setAttribute('aria-expanded', 'true');
   
           // Unhide first, then force a reflow so scrollHeight is correct
           panel.hidden = false;
           panel.classList.add('is-open');
           // Force reflow to ensure accurate scrollHeight after removing [hidden]
           // (particularly important if any CSS sets [hidden]{display:none!important})
           void panel.offsetHeight;
   
           if (prefersReduced) {
             panel.style.maxHeight = 'none';
             return resolve();
           }
   
           panel.style.maxHeight = panel.scrollHeight + 'px';
           onTransitionEndOnce(panel, 'max-height', () => {
             panel.style.maxHeight = 'none';
             resolve();
           });
         });
       }
   
   
       function getOpenItems() {
         return Array.from(items).filter(i => i.querySelector('.fs-trigger')?.getAttribute('aria-expanded') === 'true');
       }
   
       items.forEach((item, idx) => {
         const btn = item.querySelector('.fs-trigger');
         if (!btn) return;
   
         btn.addEventListener('click', async () => {
           const expanded = btn.getAttribute('aria-expanded') === 'true';
   
           if (expanded) {
             await closeItem(item);
             return;
           }
   
           if (singleOpen) {
             const openOnes = getOpenItems().filter(i => i !== item);
             if (openOnes.length) {
               await Promise.all(openOnes.map(closeItem));
             }
           }
   
           await openItem(item);
         });
   
         // keyboard navigation between headers
         btn.addEventListener('keydown', (e) => {
           if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
             e.preventDefault();
             const dir = e.key === 'ArrowDown' ? 1 : -1;
             const next = (idx + dir + items.length) % items.length;
             items[next].querySelector('.fs-trigger')?.focus();
           }
         });
       });
   
       // Open first item if requested
       if (openFirst) {
         const first = items[0];
         if (first) openItem(first);
       }
   
       // Reduced motion: make transitions effectively instant
       if (prefersReduced) {
         el.querySelectorAll('.fs-panel').forEach(p => {
           p.style.transition = 'max-height .001s linear, opacity .001s linear, transform .001s linear';
         });
       }
   
       // Unbind helper for Theme Editor
       el.__faq_unbind__ = () => {
         items.forEach((item) => {
           const btn = item.querySelector('.fs-trigger');
           if (!btn) return;
           btn.replaceWith(btn.cloneNode(true)); // quick remove listeners
         });
         delete el.dataset.faqBound;
         delete el.__faq_unbind__;
       };
     }
   
     function bindAll(scope = document) {
       scope.querySelectorAll(SELECTOR).forEach(bindSplitFaqs);
     }
   
     document.addEventListener('DOMContentLoaded', () => bindAll());
     document.addEventListener('shopify:section:load', (e) => bindAll(e.target));
     document.addEventListener('shopify:section:unload', (e) => {
       e.target?.querySelectorAll(SELECTOR).forEach(s => s.__faq_unbind__ && s.__faq_unbind__());
     });
   })();
   
   
   /* ---------------------------------
      Announcement bar — messages rotator (fixed)
      --------------------------------- */
   (function () {
     const RENDER_ATTR = 'annBound';
   
     function initAnnouncementMessages(root) {
       // Accept either the announcement-bar node or a parent that contains it
       const wrap = root.matches?.('.announcement-bar[data-variant="messages"]')
         ? root
         : root.querySelector?.('.announcement-bar[data-variant="messages"]');
   
       if (!wrap || wrap.dataset[RENDER_ATTR] === '1') return;
       wrap.dataset[RENDER_ATTR] = '1';
   
       const track = wrap.querySelector('.announcement-bar__track');
       const slides = Array.from(wrap.querySelectorAll('.announcement-bar__slide'));
       const prevBtn = wrap.querySelector('.announcement-bar__nav.prev');
       const nextBtn = wrap.querySelector('.announcement-bar__nav.next');
       const viewport = wrap.querySelector('.announcement-bar__viewport');
       const mode = wrap.getAttribute('data-animation') || 'fade';
       const autoplay = (wrap.getAttribute('data-autoplay') || 'false') === 'true';
       const interval = parseInt(wrap.getAttribute('data-interval') || '4000', 10);
       const loop = (wrap.getAttribute('data-loop') || 'true') === 'true';
       const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
   
       if (!track || slides.length === 0) return;
   
       // Single slide → show it and bail
       if (slides.length === 1) {
         slides[0].classList.add('is-active');
         viewport && viewport.removeAttribute('tabindex');
         return;
       }
   
       // Keyboard focus target
       if (viewport && !viewport.hasAttribute('tabindex')) {
         viewport.setAttribute('tabindex', '0');
       }
   
       // ---- Layout for slide mode (self-contained) ----
       if (mode === 'slide') {
         track.style.display = 'flex';
         track.style.willChange = 'transform';
         track.style.transition = reduceMotion ? 'none' : 'transform .35s ease';
         slides.forEach(s => {
           s.style.flex = '0 0 100%';
           s.style.maxWidth = '100%';
         });
       }
   
       let index = 0;
       const clamp = i => (i + slides.length) % slides.length;
   
       function applyA11y() {
         slides.forEach((s, i) => {
           const active = i === index;
           s.classList.toggle('is-active', active);
           s.setAttribute('aria-hidden', active ? 'false' : 'true');
   
           // Make non-active slides unfocusable
           s.querySelectorAll('a,button,[tabindex]:not([tabindex="-1"])').forEach(el => {
             if (active) el.removeAttribute('tabindex');
             else el.setAttribute('tabindex', '-1');
           });
         });
       }
   
       function render() {
         if (mode === 'slide') {
           track.style.transform = `translateX(${index * -100}%)`;
         } else {
           // fade: .is-active toggled in applyA11y
         }
         applyA11y();
         restartAutoplayTick();
       }
   
       function setActive(i) {
         const next = clamp(i);
         if (next === index) return;
         index = next;
         render();
       }
   
       function next() { setActive(index + 1); }
       function prev() { setActive(index - 1); }
   
       // Initial state
       if (mode === 'slide') {
         index = 0;
         render();
       } else {
         slides.forEach((s, i) => s.classList.toggle('is-active', i === 0));
         applyA11y();
       }
   
       // Click handlers (safe if missing)
       nextBtn && nextBtn.addEventListener('click', next);
       prevBtn && prevBtn.addEventListener('click', prev);
   
       // Keyboard left/right on viewport
       viewport && viewport.addEventListener('keydown', (e) => {
         if (e.key === 'ArrowRight') { e.preventDefault(); next(); }
         if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); }
       });
   
       // --- Autoplay (optional) ---
       let tId = null;
       let startedAt = 0;
       let remaining = interval;
       let paused = false;
   
       function clearTick() { if (tId) { clearTimeout(tId); tId = null; } }
       function schedule(ms) {
         clearTick();
         if (!autoplay || reduceMotion) return;
         if (paused) return;
         startedAt = Date.now();
         tId = setTimeout(() => { tId = null; next(); }, ms);
       }
       function restartAutoplayTick() {
         if (!autoplay || reduceMotion) return;
         remaining = interval;
         if (!paused) schedule(remaining);
       }
       function pause() {
         if (!autoplay || reduceMotion) return;
         if (tId) {
           const elapsed = Date.now() - startedAt;
           remaining = Math.max(1, remaining - elapsed);
         }
         paused = true;
         clearTick();
       }
       function resume() {
         if (!autoplay || reduceMotion) return;
         paused = false;
         schedule(remaining || interval);
       }
   
       // Pause on hover and focus within
       wrap.addEventListener('mouseenter', pause);
       wrap.addEventListener('mouseleave', resume);
       wrap.addEventListener('focusin', pause);
       wrap.addEventListener('focusout', resume);
   
       // Pause when page/tab hidden
       document.addEventListener('visibilitychange', () => {
         if (document.hidden) pause(); else resume();
       });
   
       // Kick off autoplay
       restartAutoplayTick();
   
       // Resize safeguard (keeps transforms crisp)
       let rTO;
       window.addEventListener('resize', () => {
         clearTimeout(rTO);
         rTO = setTimeout(() => {
           // re-apply transform to current slide
           if (mode === 'slide') track.style.transform = `translateX(${index * -100}%)`;
         }, 150);
       }, { passive: true });
   
       // Unbind helper for the theme editor
       wrap.__ann_unbind__ = () => {
         nextBtn && nextBtn.replaceWith(nextBtn.cloneNode(true));
         prevBtn && prevBtn.replaceWith(prevBtn.cloneNode(true));
         viewport && viewport.replaceWith(viewport.cloneNode(true));
         clearTick();
         delete wrap.dataset[RENDER_ATTR];
         delete wrap.__ann_unbind__;
       };
     }
   
     function bindAnnouncementMessages(scope = document) {
       scope.querySelectorAll('.announcement-bar[data-variant="messages"]').forEach(initAnnouncementMessages);
     }
   
     function destroyAnnouncementMessages(scope = document) {
       scope.querySelectorAll('.announcement-bar[data-variant="messages"]').forEach(bar => {
         bar.__ann_unbind__?.();
       });
     }
   
     // Expose (optional)
     window.initAnnouncementMessages = initAnnouncementMessages;
     window.bindAnnouncementMessages = bindAnnouncementMessages;
   
     // Auto-bind on load
     document.addEventListener('DOMContentLoaded', () => {
       bindAnnouncementMessages();
     });
   
     // Shopify Theme Editor lifecycle
     document.addEventListener('shopify:section:load', (e) => {
       bindAnnouncementMessages(e.target);
     });
     document.addEventListener('shopify:section:unload', (e) => {
       destroyAnnouncementMessages(e.target);
     });
   })();
   
   
   /* ======================================
      FAQ Deck (namespaced) — section script
      ====================================== */
   (function () {
     const REGISTRY = (window.themeSections = window.themeSections || {});
     const TYPE = 'faq-deck';
   
     function onTransitionEndOnce(el, prop, cb) {
       const handler = (e) => {
         if (e.target === el && e.propertyName === prop) {
           el.removeEventListener('transitionend', handler);
           cb && cb();
         }
       };
       el.addEventListener('transitionend', handler);
     }
   
     function init(root) {
       if (!root || root.__faqInit) return;
       root.__faqInit = true;
   
       const items = root.querySelectorAll('.fd-item');
       const btns = root.querySelectorAll('.fd-trigger');
       const search = root.querySelector('.fd-search');
       const results = root.querySelector('[data-results]');
       const singleOpen = root.dataset.singleOpen === 'true';
       const openFirst = root.dataset.openFirst === 'true';
       const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
   
       const expandAllBtn = root.querySelector('[data-expand-all]');
       const collapseAllBtn = root.querySelector('[data-collapse-all]');
   
       function closeItem(item) {
         return new Promise((resolve) => {
           const btn = item.querySelector('.fd-trigger');
           const panel = item.querySelector('.fd-panel');
           if (!btn || !panel) return resolve();
           if (btn.getAttribute('aria-expanded') === 'false') return resolve();
   
           btn.setAttribute('aria-expanded', 'false');
           if (prefersReduced) {
             panel.classList.remove('is-open');
             panel.style.maxHeight = null;
             panel.hidden = true;
             return resolve();
           }
           const current = panel.scrollHeight;
           panel.style.maxHeight = current + 'px';
           panel.offsetHeight; // force reflow
           panel.classList.remove('is-open');
           panel.style.maxHeight = '0px';
           onTransitionEndOnce(panel, 'max-height', () => {
             panel.hidden = true;
             panel.style.maxHeight = null;
             resolve();
           });
         });
       }
   
       function openItem(item, { updateHash = true } = {}) {
         return new Promise((resolve) => {
           const btn = item.querySelector('.fd-trigger');
           const panel = item.querySelector('.fd-panel');
           if (!btn || !panel) return resolve();
           if (btn.getAttribute('aria-expanded') === 'true') return resolve();
   
           btn.setAttribute('aria-expanded', 'true');
           panel.hidden = false;
           panel.classList.add('is-open');
           if (updateHash && btn.dataset.fragment) history.replaceState(null, '', btn.dataset.fragment);
   
           if (prefersReduced) {
             panel.style.maxHeight = 'none';
             return resolve();
           }
           panel.style.maxHeight = panel.scrollHeight + 'px';
           onTransitionEndOnce(panel, 'max-height', () => {
             panel.style.maxHeight = 'none';
             resolve();
           });
         });
       }
   
       function getOpenItems() {
         return Array.from(items).filter(
           (i) => i.querySelector('.fd-trigger')?.getAttribute('aria-expanded') === 'true'
         );
       }
   
       // Click + keyboard binding
       btns.forEach((btn, idx) => {
         const item = items[idx];
         btn.addEventListener('click', async () => {
           const expanded = btn.getAttribute('aria-expanded') === 'true';
           if (expanded) {
             await closeItem(item);
             return;
           }
           if (singleOpen) {
             await Promise.all(getOpenItems().filter((i) => i !== item).map(closeItem));
           }
           await openItem(item);
         });
   
         btn.addEventListener('keydown', (e) => {
           if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
             e.preventDefault();
             const dir = e.key === 'ArrowDown' ? 1 : -1;
             const next = (idx + dir + items.length) % items.length;
             items[next].querySelector('.fd-trigger').focus();
           }
         });
       });
   
       // Search filter
       if (search) {
         const all = Array.from(items).map((i) => ({
           el: i,
           text:
             (i.querySelector('.fd-question')?.textContent || '') +
             ' ' +
             (i.querySelector('.fd-answer')?.textContent || '')
         }));
         const labelNo = search.dataset.labelNo || 'No results';
         const labelOne = search.dataset.labelOne || '1 result';
         const labelMany = search.dataset.labelMany || '{count} results';
   
         search.addEventListener('input', () => {
           const q = search.value.trim().toLowerCase();
           let shown = 0;
           all.forEach(({ el, text }) => {
             const match = !q || text.toLowerCase().includes(q);
             el.style.display = match ? '' : 'none';
             if (match) shown++;
           });
           if (results) {
             if (!q) {
               results.textContent = '';
               return;
             }
             results.textContent =
               shown === 0 ? labelNo : shown === 1 ? labelOne : labelMany.replace('{count}', shown);
           }
         });
       }
   
       // Expand/Collapse all
       if (expandAllBtn)
         expandAllBtn.addEventListener('click', async () => {
           if (singleOpen) await Promise.all(getOpenItems().map(closeItem));
           for (const item of items) {
             if (item.style.display !== 'none') await openItem(item, { updateHash: false });
           }
         });
   
       if (collapseAllBtn)
         collapseAllBtn.addEventListener('click', async () => {
           for (const item of getOpenItems()) await closeItem(item);
           history.replaceState(null, '', location.pathname + location.search);
         });
   
       // Deep-link open on load (#qa-3) or open-first
       const hash = location.hash;
       if (hash && hash.startsWith('#qa-')) {
         const target = root.querySelector(hash);
         if (target) {
           openItem(target, { updateHash: false });
           target.querySelector('.fd-trigger')?.focus({ preventScroll: true });
           target.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
         }
       } else if (openFirst && items[0]) {
         openItem(items[0], { updateHash: false });
       }
   
       // Reduced motion: shorten transitions but keep ARIA states
       if (prefersReduced)
         root.querySelectorAll('.fd-panel').forEach((p) => {
           p.style.transition = 'max-height .001s linear, opacity .001s linear, transform .001s linear';
         });
   
       // Store a destroy method for Theme Editor lifecycle
       root.__faqDestroy = function () {
         // Remove listeners by cloning nodes (simple + safe)
         btns.forEach((btn) => {
           const clone = btn.cloneNode(true);
           btn.replaceWith(clone);
         });
         if (search) {
           const sClone = search.cloneNode(true);
           search.replaceWith(sClone);
         }
         if (expandAllBtn) expandAllBtn.replaceWith(expandAllBtn.cloneNode(true));
         if (collapseAllBtn) collapseAllBtn.replaceWith(collapseAllBtn.cloneNode(true));
         root.__faqInit = false;
       };
     }
   
     // Public mount helper
     REGISTRY[TYPE] = {
       onLoad(container) {
         container.querySelectorAll('[data-section-type="faq-deck"]').forEach(init);
       },
       onUnload(container) {
         container.querySelectorAll('[data-section-type="faq-deck"]').forEach((root) => {
           root.__faqDestroy && root.__faqDestroy();
         });
       }
     };
   
     // Auto-init on DOM ready + Theme Editor events
     function boot(container = document) {
       REGISTRY[TYPE].onLoad(container);
     }
     if (document.readyState === 'loading') {
       document.addEventListener('DOMContentLoaded', () => boot());
     } else {
       boot();
     }
   
     // Shopify Theme Editor hooks
     document.addEventListener('shopify:section:load', (e) => REGISTRY[TYPE].onLoad(e.target));
     document.addEventListener('shopify:section:unload', (e) => REGISTRY[TYPE].onUnload(e.target));
     document.addEventListener('shopify:section:select', (e) => REGISTRY[TYPE].onLoad(e.target));
     document.addEventListener('shopify:section:deselect', (e) => REGISTRY[TYPE].onUnload(e.target));
   })();
   
   
   /* ======================================
      Compare Image — section script
      ====================================== */
   (function () {
     const REGISTRY = (window.themeSections = window.themeSections || {});
     const TYPE = 'compare-image';
   
     function init(root) {
       if (!root || root.__cmpInit) return;
       root.__cmpInit = true;
   
       const canvas = root.querySelector('[data-compare-root]');
       const beforeEl = canvas?.querySelector('.cmp__img--before');
       const divider = canvas?.querySelector('.cmp__divider');
       const handle = canvas?.querySelector('[data-cmp-handle]');
       if (!canvas || !beforeEl || !divider || !handle) return;
   
       let pct = Math.max(0, Math.min(100, Number(root.dataset.start) || 50));
   
       function setByPct(v) {
         pct = Math.max(0, Math.min(100, v));
         const px = (pct / 100) * canvas.clientWidth;
         canvas.style.setProperty('--clip', px + 'px');
         handle.setAttribute('aria-valuenow', String(Math.round(pct)));
       }
   
       function setByClientX(clientX) {
         const rect = canvas.getBoundingClientRect();
         const x = Math.max(0, Math.min(rect.width, clientX - rect.left));
         setByPct((x / rect.width) * 100);
       }
   
       const ready = () => setByPct(pct);
       window.addEventListener('resize', ready, { passive: true });
       if (document.readyState === 'loading') {
         document.addEventListener('DOMContentLoaded', ready, { once: true });
       } else {
         ready();
       }
   
       let dragging = false;
       const start = (e) => {
         dragging = true;
         setByClientX(e.clientX ?? e.touches?.[0]?.clientX ?? 0);
       };
       const move = (e) => {
         if (!dragging) return;
         setByClientX(e.clientX ?? e.touches?.[0]?.clientX ?? 0);
       };
       const end = () => (dragging = false);
   
       // Pointer + touch
       handle.addEventListener('pointerdown', (e) => {
         e.preventDefault();
         handle.setPointerCapture(e.pointerId);
         start(e);
       });
       window.addEventListener('pointermove', move, { passive: true });
       window.addEventListener('pointerup', end, { passive: true });
   
       handle.addEventListener('touchstart', (e) => start(e.touches[0]), { passive: true });
       window.addEventListener('touchmove', move, { passive: true });
       window.addEventListener('touchend', end, { passive: true });
   
       // Keyboard (←/→ = 5%, Shift+arrow = 10%)
       handle.addEventListener('keydown', (e) => {
         const step = e.shiftKey ? 10 : 5;
         if (e.key === 'ArrowLeft') { setByPct(pct - step); e.preventDefault(); }
         if (e.key === 'ArrowRight') { setByPct(pct + step); e.preventDefault(); }
       });
   
       // Store destroy for Theme Editor lifecycle
       root.__cmpDestroy = function () {
         window.removeEventListener('resize', ready);
         const clone = handle.cloneNode(true);
         handle.replaceWith(clone);
         root.__cmpInit = false;
       };
     }
   
     REGISTRY[TYPE] = {
       onLoad(container) {
         container.querySelectorAll('[data-section-type="compare-image"]').forEach(init);
       },
       onUnload(container) {
         container.querySelectorAll('[data-section-type="compare-image"]').forEach((root) => {
           root.__cmpDestroy && root.__cmpDestroy();
         });
       }
     };
   
     // Boot + Theme Editor hooks
     function boot(container = document) { REGISTRY[TYPE].onLoad(container); }
     if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
     else boot();
   
     document.addEventListener('shopify:section:load', (e) => REGISTRY[TYPE].onLoad(e.target));
     document.addEventListener('shopify:section:unload', (e) => REGISTRY[TYPE].onUnload(e.target));
     document.addEventListener('shopify:section:select', (e) => REGISTRY[TYPE].onLoad(e.target));
     document.addEventListener('shopify:section:deselect', (e) => REGISTRY[TYPE].onUnload(e.target));
   })();
   
   
   
   /* ===================== Image + Quad Products (IQP) ===================== */
   (function () {
     const STATE = new WeakMap();
   
     function setBtn(btn, visible, disabled) {
       if (!btn) return;
       btn.setAttribute('aria-hidden', String(!visible));
       btn.setAttribute('aria-disabled', String(disabled));
       btn.classList.toggle('is-visible', visible);
       if (!visible || disabled) btn.setAttribute('tabindex', '-1');
       else btn.removeAttribute('tabindex');
     }
   
     function initIQP(section) {
       if (STATE.has(section)) return;
   
       const shell = section.querySelector('.iqp__products-shell');
       const track = section.querySelector('.iqp__track');
       const prev = section.querySelector('.iqp__nav--prev');
       const next = section.querySelector('.iqp__nav--next');
       const dots = section.querySelectorAll('.iqp__dot');
       if (!shell || !track) return;
   
       const isSlider = shell.classList.contains('is-slider');
       const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
       const pageWidth = () => track.clientWidth;
   
       function goTo(index) {
         track.scrollTo({ left: index * pageWidth(), behavior: prefersReduced ? 'auto' : 'smooth' });
       }
       function activeIndex() { return Math.round(track.scrollLeft / (pageWidth() || 1)); }
   
       // Dots
       function updateDots() {
         const i = activeIndex();
         dots.forEach((d, idx) => d.setAttribute('aria-selected', String(idx === i)));
       }
       dots.forEach((d, i) => {
         d.addEventListener('click', e => { e.preventDefault(); goTo(i); });
         d.addEventListener('keydown', e => {
           if (e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); goTo(i); }
         });
       });
   
       // Arrow keys on track
       track.addEventListener('keydown', (e) => {
         if (e.key === 'ArrowLeft') { e.preventDefault(); prev?.click(); }
         if (e.key === 'ArrowRight') { e.preventDefault(); next?.click(); }
       });
   
       function updateArrows() {
         if (!isSlider || !prev || !next) return;
         const max = track.scrollWidth - track.clientWidth;
         const x = Math.round(track.scrollLeft);
         if (x <= 0) {
           setBtn(prev, false, true);
           setBtn(next, true, false);
         } else if (x >= max - 1) {
           setBtn(prev, true, false);
           setBtn(next, false, true);
         } else {
           setBtn(prev, true, false);
           setBtn(next, true, false);
         }
       }
   
       function onScroll() { updateDots(); updateArrows(); }
       track.addEventListener('scroll', () => requestAnimationFrame(onScroll), { passive: true });
       window.addEventListener('resize', updateArrows, { passive: true });
   
       if (isSlider) {
         prev?.addEventListener('click', e => {
           e.preventDefault();
           track.scrollBy({ left: -pageWidth(), behavior: prefersReduced ? 'auto' : 'smooth' });
         });
         next?.addEventListener('click', e => {
           e.preventDefault();
           track.scrollBy({ left: pageWidth(), behavior: prefersReduced ? 'auto' : 'smooth' });
         });
       }
   
       // Initial state
       updateDots();
       updateArrows();
   
       // Save for unload
       STATE.set(section, { track });
     }
   
     function initAll() {
       document.querySelectorAll('.image-quad-products').forEach(initIQP);
     }
   
     document.addEventListener('DOMContentLoaded', initAll);
     document.addEventListener('shopify:section:load', e => {
       const s = e?.target;
       if (s && s.querySelector('.image-quad-products')) initAll();
     });
   })();
   
   
   /* ==== Product Recommendations: reveal on scroll ==== */
   (function () {
     function initProductRecs(rootEl) {
       if (!rootEl) return;
   
       const revealEls = Array.from(rootEl.querySelectorAll('[data-reveal]'));
       if (!revealEls.length) return;
   
       // No IO? Just show immediately.
       if (!('IntersectionObserver' in window)) {
         revealEls.forEach((el) => el.classList.add('is-visible'));
         return;
       }
   
       const io = new IntersectionObserver(
         (entries) => {
           entries.forEach((entry) => {
             if (entry.isIntersecting) {
               entry.target.classList.add('is-visible');
               io.unobserve(entry.target);
             }
           });
         },
         { rootMargin: '0px 0px -10% 0px', threshold: 0.01 }
       );
   
       revealEls.forEach((el) => io.observe(el));
     }
   
     function initAll() {
       document
         .querySelectorAll('.section-product-recommendations .product-recommendations')
         .forEach(initProductRecs);
     }
   
     if (document.readyState === 'loading') {
       document.addEventListener('DOMContentLoaded', initAll, { once: true });
     } else {
       initAll();
     }
   
     // Theme editor support
     document.addEventListener('shopify:section:load', (e) => {
       const section = e.target;
       if (section?.classList?.contains('section-product-recommendations')) {
         const root = section.querySelector('.product-recommendations');
         initProductRecs(root);
       }
     });
   
     document.addEventListener('product-recommendations:updated', (event) => {
       const root = event?.detail?.root;
       if (root) initProductRecs(root);
     });
   })();
   /* ==== Rich Text: small reveal helper ==== */
   (function () {
     function initRichText(root) {
       if (!root) return;
       const items = root.querySelectorAll('[data-reveal]');
       if (!items.length) return;
   
       if (!('IntersectionObserver' in window)) {
         items.forEach(el => el.classList.add('is-visible'));
         return;
       }
   
       const io = new IntersectionObserver((entries) => {
         entries.forEach((en) => {
           if (en.isIntersecting) {
             en.target.classList.add('is-visible');
             io.unobserve(en.target);
           }
         });
       }, { rootMargin: '0px 0px -10% 0px', threshold: 0.01 });
   
       items.forEach(el => io.observe(el));
     }
   
     function boot() {
       document.querySelectorAll('.section-rich-text .rich-text').forEach(initRichText);
     }
   
     if (document.readyState === 'loading') {
       document.addEventListener('DOMContentLoaded', boot, { once: true });
     } else {
       boot();
     }
   
     document.addEventListener('shopify:section:load', (e) => {
       const sec = e.target;
       if (sec?.classList?.contains('section-rich-text')) {
         initRichText(sec.querySelector('.rich-text'));
       }
     });
   })();
   /* ==== Marquee / Moving Text ==== */
   (function () {
     function initMarquee(root) {
       const el = root.querySelector('.js-marquee');
       if (!el) return;
   
       const reverse = String(el.dataset.reverse) === 'true';
       const pause = String(el.dataset.pause) === 'true';
       const speed = parseInt(el.dataset.speed || '40', 10);
   
       el.classList.toggle('is-reversed', reverse);
       el.classList.toggle('is-pausable', pause);
   
       // Compute an animation duration that scales with container/content width.
       const ro = ('ResizeObserver' in window) ? new ResizeObserver((entries) => {
         const entry = entries[0];
         const containerW = Math.max(1, entry.contentRect.width);
         const firstSpan = el.querySelector('span');
         if (!firstSpan) return;
   
         const contentW = Math.max(1, firstSpan.clientWidth);
   
         // Slow factor across breakpoints (keeps perceived speed stable)
         let slowFactor = 1;
         if (containerW <= 375) slowFactor = 1;
         else if (containerW >= 1280) slowFactor = 3;
         else slowFactor = 1 + (containerW - 375) / (1280 - 375);
   
         const duration = (speed * slowFactor * contentW / containerW).toFixed(3);
         el.style.setProperty('--bullet-speed', duration + 's');
       }) : null;
   
       if (ro) ro.observe(el);
     }
   
     function bootAll(scope = document) {
       scope.querySelectorAll('.marquee').forEach(initMarquee);
     }
   
     if (document.readyState === 'loading') {
       document.addEventListener('DOMContentLoaded', () => bootAll(), { once: true });
     } else {
       bootAll();
     }
   
     document.addEventListener('shopify:section:load', (e) => {
       if (e?.target) bootAll(e.target);
     });
   })();
   /* ==== Showcase Collection (slider helpers) ==== */
   (function () {
     function initShowcase(section) {
       const wrapper = section.querySelector('.showcase-collection__wrapper.is-slider');
       if (!wrapper) return;
   
       const track = wrapper.querySelector('.showcase-collection__grid');
       const prev = wrapper.querySelector('.slider-nav.prev');
       const next = wrapper.querySelector('.slider-nav.next');
       if (!track || !prev || !next) return;
   
       const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
       const step = () => track.clientWidth;
   
       function setNavState() {
         const canScroll = track.scrollWidth > track.clientWidth + 1;
         const atStart = track.scrollLeft <= 0;
         const atEnd = Math.ceil(track.scrollLeft + track.clientWidth) >= track.scrollWidth;
   
         [prev, next].forEach(btn => {
           btn.classList.toggle('is-visible', canScroll);
           btn.setAttribute('aria-hidden', String(!canScroll));
         });
   
         prev.setAttribute('aria-disabled', String(atStart || !canScroll));
         next.setAttribute('aria-disabled', String(atEnd || !canScroll));
         prev.tabIndex = (atStart || !canScroll) ? -1 : 0;
         next.tabIndex = (atEnd || !canScroll) ? -1 : 0;
       }
   
       function scrollBy(delta) {
         track.scrollBy({ left: delta, behavior: prefersReduced ? 'auto' : 'smooth' });
       }
   
       prev.addEventListener('click', e => { e.preventDefault(); scrollBy(-step()); });
       next.addEventListener('click', e => { e.preventDefault(); scrollBy(step()); });
   
       track.addEventListener('keydown', e => {
         if (e.key === 'ArrowLeft') { e.preventDefault(); prev.click(); }
         if (e.key === 'ArrowRight') { e.preventDefault(); next.click(); }
       });
   
       let raf;
       const onScroll = () => {
         if (raf) cancelAnimationFrame(raf);
         raf = requestAnimationFrame(setNavState);
       };
   
       track.addEventListener('scroll', onScroll, { passive: true });
       window.addEventListener('resize', setNavState, { passive: true });
   
       setNavState();
     }
   
     function boot(scope = document) {
       scope.querySelectorAll('[data-section-type="showcase-collection"]').forEach(initShowcase);
     }
   
     if (document.readyState === 'loading') {
       document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
     } else {
       boot();
     }
   
     document.addEventListener('shopify:section:load', (e) => { if (e?.target) boot(e.target); });
   })();
   /* =========================================
      Showcase Grid / Carousel initializer
      - No inline handlers; Theme Store safe
      - Desktop-only arrows, mobile disabled
      ========================================= */
   
   function initShowcaseGridCarousel(root) {
     if (!root || root.dataset.sgBound === '1') return;
     root.dataset.sgBound = '1';
   
     const shell = root.querySelector('.slider-shell');
     const track = shell && shell.querySelector('.track');
     const prevBtn = shell && shell.querySelector('.slider-nav.prev');
     const nextBtn = shell && shell.querySelector('.slider-nav.next');
   
     if (!shell || !track || !prevBtn || !nextBtn) return;
   
     const enableDesktop = shell.getAttribute('data-enable-desktop') === 'true';
     const enableMobile = shell.getAttribute('data-enable-mobile') === 'true';
   
     const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
     const isMobile = () => window.matchMedia('(max-width: 749px)').matches;
     const getPage = () => track.clientWidth;
   
     const setBtnState = (btn, { visible, disabled }) => {
       btn.classList.toggle('is-visible', !!visible);
       btn.setAttribute('aria-hidden', String(!visible));
       btn.setAttribute('aria-disabled', String(!!disabled));
       if (disabled || !visible) btn.setAttribute('tabindex', '-1');
       else btn.removeAttribute('tabindex');
     };
   
     const update = () => {
       // Respect flags from settings
       const mobileNow = isMobile();
       const sliderActive = (mobileNow && enableMobile) || (!mobileNow && enableDesktop);
   
       // If not a slider in current viewport, hide arrows entirely
       if (!sliderActive || mobileNow) {
         setBtnState(prevBtn, { visible: false, disabled: true });
         setBtnState(nextBtn, { visible: false, disabled: true });
         return;
       }
   
       const scrollLeft = Math.round(track.scrollLeft);
       const max = track.scrollWidth - track.clientWidth;
   
       if (scrollLeft <= 0) {
         setBtnState(prevBtn, { visible: false, disabled: true });
         setBtnState(nextBtn, { visible: true, disabled: false });
       } else if (scrollLeft >= max - 1) {
         setBtnState(prevBtn, { visible: true, disabled: false });
         setBtnState(nextBtn, { visible: false, disabled: true });
       } else {
         setBtnState(prevBtn, { visible: true, disabled: false });
         setBtnState(nextBtn, { visible: true, disabled: false });
       }
     };
   
     prevBtn.addEventListener('click', (e) => {
       e.preventDefault();
       if (isMobile() || shell.getAttribute('data-enable-desktop') !== 'true') return;
       track.scrollBy({ left: -getPage(), behavior: prefersReduced ? 'auto' : 'smooth' });
     });
   
     nextBtn.addEventListener('click', (e) => {
       e.preventDefault();
       if (isMobile() || shell.getAttribute('data-enable-desktop') !== 'true') return;
       track.scrollBy({ left: getPage(), behavior: prefersReduced ? 'auto' : 'smooth' });
     });
   
     let raf;
     const onScroll = () => {
       if (raf) cancelAnimationFrame(raf);
       raf = requestAnimationFrame(update);
     };
   
     track.addEventListener('scroll', onScroll, { passive: true });
     window.addEventListener('resize', update, { passive: true });
   
     // initial
     update();
   }
   
   /* Auto-bind on load + Theme Editor events */
   document.addEventListener('DOMContentLoaded', () => {
     document.querySelectorAll('.custom-grid-section').forEach(initShowcaseGridCarousel);
   });
   
   /* ---------------------------------
      NEWSLETTER SIGNUP (AJAX)
      --------------------------------- */
   (() => {
     const SELECTOR = '[data-newsletter-form]';
     const STORAGE_KEY = 'theme.newsletterSignup';
     const DEFAULT_SUCCESS = "You're on the list. Expect curated updates soon.";
     const GENERIC_ERROR = "We couldn't process your request. Please try again.";
     const NETWORK_ERROR = "We couldn't connect. Please try again.";
   
     const getElements = (form) => {
       if (!form) return {};
       return {
         fields: form.querySelector('[data-newsletter-fields]'),
         input: form.querySelector('[data-newsletter-input]'),
         button: form.querySelector('[data-newsletter-submit]'),
         success: form.querySelector('[data-newsletter-success]'),
         error: form.querySelector('[data-newsletter-error]'),
       };
     };
   
     const getSuccessMessage = (form) => {
       const value = form?.dataset?.newsletterSuccessText || '';
       const trimmed = value.trim();
       return trimmed.length ? trimmed : DEFAULT_SUCCESS;
     };
   
     const ensureOriginalPlaceholder = (input) => {
       if (!input) return;
       if (!Object.prototype.hasOwnProperty.call(input.dataset, 'newsletterOriginalPlaceholder')) {
         const original = input.getAttribute('placeholder') || '';
         input.dataset.newsletterOriginalPlaceholder = original;
       }
     };
   
     const setLocked = (form, elements, locked, email) => {
       if (!form || !elements) return;
       const { fields, input, button } = elements;
   
       if (locked) {
         form.dataset.newsletterLocked = 'true';
         if (fields) fields.dataset.newsletterLocked = 'true';
         if (input) {
           ensureOriginalPlaceholder(input);
           if (email) input.value = email;
           input.disabled = true;
           input.setAttribute('aria-disabled', 'true');
           input.removeAttribute('aria-invalid');
         }
         if (button) {
           button.disabled = true;
           button.setAttribute('aria-disabled', 'true');
         }
       } else {
         delete form.dataset.newsletterLocked;
         if (fields) delete fields.dataset.newsletterLocked;
         if (input) {
           input.disabled = false;
           input.removeAttribute('aria-disabled');
           input.removeAttribute('title');
           if (Object.prototype.hasOwnProperty.call(input.dataset, 'newsletterOriginalPlaceholder')) {
             input.setAttribute('placeholder', input.dataset.newsletterOriginalPlaceholder);
           }
         }
         if (button) {
           button.disabled = false;
           button.removeAttribute('aria-disabled');
         }
       }
     };
   
     const clearFeedback = (form, elements) => {
       if (!elements) return;
       if (elements.error) {
         elements.error.textContent = '';
         elements.error.hidden = true;
       }
       if (elements.success && form.dataset.newsletterLocked !== 'true') {
         elements.success.hidden = true;
       }
       if (elements.input) {
         elements.input.removeAttribute('aria-invalid');
       }
     };
   
     const showError = (form, elements, message) => {
       if (!elements) return;
       setLocked(form, elements, false);
       if (elements.success) elements.success.hidden = true;
       if (elements.error) {
         elements.error.textContent = message;
         elements.error.hidden = false;
       }
       if (elements.input && typeof elements.input.focus === 'function') {
         elements.input.setAttribute('aria-invalid', 'true');
         elements.input.focus();
       }
     };
   
     const setSuccess = (form, elements, message, email) => {
       if (!elements) return;
       const successMsg = message || getSuccessMessage(form);
       if (elements.success) {
         elements.success.textContent = successMsg;
         elements.success.hidden = false;
       }
       if (elements.error) {
         elements.error.textContent = '';
         elements.error.hidden = true;
       }
       setLocked(form, elements, true, email);
       if (elements.input) {
         ensureOriginalPlaceholder(elements.input);
         if (email) {
           elements.input.value = email;
         } else {
           elements.input.value = '';
         }
         const original = elements.input.dataset.newsletterOriginalPlaceholder || '';
         if (original) {
           elements.input.setAttribute('placeholder', original);
         }
         elements.input.setAttribute('title', successMsg);
       }
     };
   
     const parseErrorMessage = (payload) => {
       if (!payload) return '';
       if (typeof payload === 'string') {
         const trimmed = payload.trim();
         return trimmed.length ? trimmed : '';
       }
       if (typeof payload.message === 'string' && payload.message.trim()) {
         return payload.message.trim();
       }
       if (typeof payload.description === 'string' && payload.description.trim()) {
         return payload.description.trim();
       }
       if (payload.errors) {
         if (typeof payload.errors === 'string') return payload.errors;
         if (Array.isArray(payload.errors)) return payload.errors.join(' ');
         if (typeof payload.errors === 'object') {
           const messages = [];
           Object.values(payload.errors).forEach((value) => {
             if (!value) return;
             if (Array.isArray(value)) {
               messages.push(value.join(' '));
             } else if (typeof value === 'string') {
               messages.push(value);
             } else if (value && typeof value.message === 'string') {
               messages.push(value.message);
             }
           });
           return messages.join(' ');
         }
       }
       return '';
     };
   
     const responseHasErrors = (payload) => {
       if (!payload) return false;
       if (typeof payload === 'string') return false;
       if (payload.status === 'success' || payload.success === true) return false;
       if (payload.errors) {
         if (Array.isArray(payload.errors)) return payload.errors.length > 0;
         if (typeof payload.errors === 'object') return Object.keys(payload.errors).length > 0;
         return Boolean(payload.errors);
       }
       return payload.status === 'error';
     };
   
     const readStoredState = () => {
       try {
         const raw = window.localStorage.getItem(STORAGE_KEY);
         if (!raw) return null;
         const parsed = JSON.parse(raw);
         return parsed && typeof parsed === 'object' ? parsed : null;
       } catch (error) {
         return null;
       }
     };
   
     const writeStoredState = (state) => {
       try {
         window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
         return true;
       } catch (error) {
         return false;
       }
     };
   
     const applySuccessAcrossForms = (state, root = document) => {
       if (!root || typeof root.querySelectorAll !== 'function') return;
       root.querySelectorAll(SELECTOR).forEach((form) => {
         const elements = getElements(form);
         setSuccess(form, elements, getSuccessMessage(form), state?.email || '');
       });
     };
   
     const applyStoredSuccess = (root = document) => {
       const state = readStoredState();
       if (state) applySuccessAcrossForms(state, root);
     };
   
     const setSubmitting = (form, elements, submitting) => {
       if (!elements?.button) return;
       if (submitting) {
         elements.button.disabled = true;
         elements.button.setAttribute('aria-disabled', 'true');
         elements.button.setAttribute('aria-busy', 'true');
         elements.button.classList.add('is-loading');
       } else {
         elements.button.classList.remove('is-loading');
         elements.button.removeAttribute('aria-busy');
         if (form.dataset.newsletterLocked === 'true') return;
         elements.button.disabled = false;
         elements.button.removeAttribute('aria-disabled');
       }
     };
   
     const handleSubmit = async (event) => {
       event.preventDefault();
       const form = event.currentTarget;
       if (!form || form.dataset.newsletterSubmitting === 'true' || form.dataset.newsletterLocked === 'true') return;
       form.dataset.newsletterSubmitting = 'true';
       const elements = getElements(form);
       clearFeedback(form, elements);
       setSubmitting(form, elements, true);
   
       const formData = new FormData(form);
       const action = form.getAttribute('action') || window.location.href;
       const emailValue = elements.input?.value?.trim() || '';
   
       try {
         const response = await fetch(action, {
           method: 'POST',
           headers: {
             Accept: 'application/json',
             'X-Requested-With': 'XMLHttpRequest',
           },
           body: formData,
           credentials: 'same-origin',
         });
         const contentType = response.headers.get('content-type') || '';
         let payload;
         if (contentType.includes('application/json')) {
           payload = await response.json();
         } else {
           const text = await response.text();
           try {
             payload = JSON.parse(text);
           } catch {
             payload = text;
           }
         }
   
         const succeeded = (response.ok && !responseHasErrors(payload))
           || (payload && (payload.status === 'success' || payload.success === true));
   
         if (succeeded) {
           const email = emailValue || (payload?.contact?.email ?? '');
           const state = { email, timestamp: Date.now() };
           writeStoredState(state);
           applySuccessAcrossForms(state, document);
         } else {
           const message = parseErrorMessage(payload) || GENERIC_ERROR;
           showError(form, elements, message);
         }
       } catch (error) {
         console.error('Newsletter submission failed', error);
         showError(form, elements, NETWORK_ERROR);
       } finally {
         setSubmitting(form, elements, false);
         delete form.dataset.newsletterSubmitting;
       }
     };
   
     const bindForm = (form) => {
       if (!form || form.dataset.newsletterBound === 'true') return;
       form.dataset.newsletterBound = 'true';
       const elements = getElements(form);
       ensureOriginalPlaceholder(elements.input);
   
       const lockedByMarkup = elements.fields?.dataset.newsletterLocked === 'true';
       if (lockedByMarkup) {
         const email = elements.input?.value?.trim() || '';
         setLocked(form, elements, true, email);
         const state = { email, timestamp: Date.now() };
         if (!writeStoredState(state)) {
           applySuccessAcrossForms(state, document);
         }
       } else {
         if (elements.success && !elements.success.textContent.trim()) elements.success.hidden = true;
         if (elements.error && !elements.error.textContent.trim()) elements.error.hidden = true;
       }
   
       form.addEventListener('submit', handleSubmit);
     };
   
     const bindAll = (root = document) => {
       if (!root || typeof root.querySelectorAll !== 'function') return;
       root.querySelectorAll(SELECTOR).forEach(bindForm);
     };
   
     const boot = (root = document) => {
       bindAll(root);
       applyStoredSuccess(root);
     };
   
     if (document.readyState === 'loading') {
       document.addEventListener('DOMContentLoaded', () => boot());
     } else {
       boot();
     }
   
     document.addEventListener('shopify:section:load', (event) => {
       const scope = event?.target || document;
       bindAll(scope);
       applyStoredSuccess(document);
     });
   })();
   
   document.addEventListener('shopify:section:load', (e) => {
     const root = e && e.target && e.target.matches('.custom-grid-section') ? e.target : e?.target?.querySelector?.('.custom-grid-section');
     if (root) initShowcaseGridCarousel(root);
   });
   
   document.addEventListener('shopify:section:select', (e) => {
     const root = e?.target?.closest?.('.custom-grid-section');
     if (root) initShowcaseGridCarousel(root);
   });
   /* =========================================
      Image-Overlay Slideshow initializer
      - 1 slide per view, cross-fade
      - Autoplay with pause on hover/visibility
      - Dots with progress bar (CSS)
      - Pauses videos on inactive slide
      ========================================= */
   
   function initImageOverlaySlideshow(sectionRoot) {
     if (!sectionRoot || sectionRoot.dataset.ioBound === '1') return;
     sectionRoot.dataset.ioBound = '1';
   
     const root = sectionRoot.querySelector('.io-slideshow');
     if (!root) return;
   
     const track = root.querySelector('.io-slideshow__track');
     const slides = Array.from(root.querySelectorAll('.io-slideshow__slide'));
     const dots = Array.from(root.querySelectorAll('.io-slideshow__dot'));
   
     const loop = String(root.dataset.loop) === 'true';
     const autoplay = String(root.dataset.autoplay) === 'true';
     const interval = parseInt(root.dataset.interval || '5000', 10);
   
     // reflect interval to CSS for the dot progress
     root.style.setProperty('--io-interval', interval + 'ms');
   
     let index = Math.max(0, slides.findIndex(s => s.classList.contains('is-active')));
     if (index < 0) index = 0;
   
     // Autoplay timeline
     let autoplayTimeout = null;
     let tickStart = 0;
     let remainingMs = interval;
     let isHovered = false;
   
     // Equalize heights
     let ro;
     function equalizeHeights() {
       sectionRoot.style.setProperty('--io-maxh', 'auto');
       let max = 0;
       slides.forEach(s => {
         const prevO = s.style.opacity, prevPE = s.style.pointerEvents;
         s.style.opacity = '1'; s.style.pointerEvents = 'auto';
         const h = s.offsetHeight;
         if (h > max) max = h;
         s.style.opacity = prevO || ''; s.style.pointerEvents = prevPE || '';
       });
       sectionRoot.style.setProperty('--io-maxh', (max || 0) + 'px');
     }
     function initHeightObservers() {
       if (window.ResizeObserver) {
         ro = new ResizeObserver(equalizeHeights);
         slides.forEach(s => ro.observe(s));
       }
       let to = null;
       window.addEventListener('resize', () => { clearTimeout(to); to = setTimeout(equalizeHeights, 100); });
   
       const media = root.querySelectorAll('img, video');
       media.forEach(m => {
         if ((m.complete && m.naturalWidth) || (m.readyState && m.readyState >= 2)) return;
         m.addEventListener('load', equalizeHeights, { once: true });
         m.addEventListener('loadeddata', equalizeHeights, { once: true });
       });
     }
   
     // Stagger setup
     const CONTENT_SELECTOR = [
       '[data-io-anim]', '.subheading', '.eyebrow',
       'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
       '.rte p', 'p', '.button', 'a.button', '.btn', 'a.btn'
     ].join(',');
   
     function primeSlideForStagger(slide) {
       const flat = Array.from(slide.querySelectorAll(CONTENT_SELECTOR))
         .filter((el, _, arr) => !arr.some(other => other !== el && other.contains(el)));
       flat.forEach((el, i) => {
         if (!el.hasAttribute('data-io-anim')) el.setAttribute('data-io-anim', '');
         el.style.setProperty('--io-stagger', i.toString());
       });
     }
     slides.forEach(primeSlideForStagger);
   
     // Dot loader utilities
     function retriggerDotLoader(activeDot) {
       if (!activeDot) return;
       const bar = activeDot.querySelector('.io-slideshow__dot-bar');
       if (bar) {
         const clone = bar.cloneNode(true);
         bar.replaceWith(clone); // restart CSS animation
       }
     }
   
     function updateUI() {
       slides.forEach((s, i) => {
         const active = i === index;
         s.classList.toggle('is-active', active);
         s.setAttribute('aria-hidden', active ? 'false' : 'true');
   
         const focusables = s.querySelectorAll('a,button,input,textarea,select,[tabindex]');
         focusables.forEach(el => { if (!active) el.setAttribute('tabindex', '-1'); else el.removeAttribute('tabindex'); });
       });
   
       dots.forEach((d, i) => {
         const active = i === index;
         d.classList.toggle('is-active', active);
         d.setAttribute('aria-selected', active ? 'true' : 'false');
         if (active) retriggerDotLoader(d);
       });
   
       // Video handling
       slides.forEach((s, i) => {
         s.querySelectorAll('video').forEach(v => {
           try {
             if (i === index) {
               if (v.muted && (v.autoplay || v.hasAttribute('autoplay'))) v.play().catch(() => { });
             } else { v.pause(); }
           } catch (e) { }
         });
       });
     }
   
     function goTo(i) {
       const last = slides.length - 1;
       if (i < 0) i = loop ? last : 0;
       if (i > last) i = loop ? 0 : last;
       if (i === index) return;
   
       // Set direction hint for potential content nudges
       const dir = i > index ? 1 : -1;
       sectionRoot.style.setProperty('--io-dir', String(dir));
   
       index = i;
       updateUI();
   
       // reset timing to full interval
       remainingMs = interval;
       if (autoplay) {
         if (isHovered || document.hidden) {
           sectionRoot.classList.add('is-paused');
           clearAutoplay();
         } else {
           scheduleNext(remainingMs);
         }
       }
     }
   
     // --- Autoplay helpers ---
     function clearAutoplay() {
       if (autoplayTimeout) { clearTimeout(autoplayTimeout); autoplayTimeout = null; }
     }
     function scheduleNext(ms) {
       clearAutoplay();
       if (!autoplay || slides.length < 2 || isHovered || document.hidden) {
         remainingMs = ms;
         sectionRoot.classList.add('is-paused');
         return;
       }
       remainingMs = ms;
       tickStart = Date.now();
       autoplayTimeout = setTimeout(() => { autoplayTimeout = null; goTo(index + 1); }, ms);
       sectionRoot.classList.remove('is-paused');
     }
     function pauseAutoplay() {
       if (!autoplay) return;
       if (autoplayTimeout) {
         const elapsed = Date.now() - tickStart;
         remainingMs = Math.max(1, (remainingMs || interval) - elapsed);
       }
       clearAutoplay();
       sectionRoot.classList.add('is-paused');
     }
     function resumeAutoplay() { if (autoplay) scheduleNext(remainingMs || interval); }
   
     // Delegated clicks for arrows + dots
     root.addEventListener('click', (e) => {
       const ctrl = e.target.closest('[data-action="prev"], [data-action="next"], .io-slideshow__dot');
       if (!ctrl || !root.contains(ctrl)) return;
       e.preventDefault();
       if (ctrl.matches('[data-action="prev"]')) { goTo(index - 1); return; }
       if (ctrl.matches('[data-action="next"]')) { goTo(index + 1); return; }
       if (ctrl.matches('.io-slideshow__dot')) {
         const i = parseInt(ctrl.dataset.index, 10);
         if (!Number.isNaN(i)) goTo(i);
       }
     });
   
     // Hover pause
     root.addEventListener('mouseenter', () => { isHovered = true; pauseAutoplay(); });
     root.addEventListener('mouseleave', () => { isHovered = false; resumeAutoplay(); });
   
     // Page visibility pause
     document.addEventListener('visibilitychange', () => {
       if (document.hidden) pauseAutoplay(); else resumeAutoplay();
     });
   
     // Basic swipe
     let startX = null;
     root.addEventListener('pointerdown', (e) => {
       if (e.target.closest('.io-arrow, .io-slideshow__dots, a, button')) return; // ignore controls
       startX = e.clientX;
       const surf = e.target.closest('.io-slideshow__track, .io-slideshow__slide');
       if (surf && root.setPointerCapture) root.setPointerCapture(e.pointerId);
     });
     root.addEventListener('pointerup', (e) => {
       if (startX === null) return;
       const dx = e.clientX - startX;
       if (Math.abs(dx) > 40) { dx < 0 ? goTo(index + 1) : goTo(index - 1); }
       startX = null;
     });
     root.addEventListener('pointercancel', () => { startX = null; });
   
     // Init
     updateUI();
     equalizeHeights();
     initHeightObservers();
     if (autoplay) scheduleNext(interval);
   }
   
   /* Auto-bind */
   document.addEventListener('DOMContentLoaded', () => {
     document.querySelectorAll('.section-image-overlay-slideshow').forEach(initImageOverlaySlideshow);
   });
   document.addEventListener('shopify:section:load', (e) => {
     const root = e?.target?.matches?.('.section-image-overlay-slideshow') ? e.target : e?.target?.querySelector?.('.section-image-overlay-slideshow');
     if (root) initImageOverlaySlideshow(root);
   });
   document.addEventListener('shopify:section:select', (e) => {
     const root = e?.target?.closest?.('.section-image-overlay-slideshow');
     if (root) initImageOverlaySlideshow(root);
   });
   
   
   /* ================================
      Add to Cart Controller
      - Binds to elements with [data-atc-root]
      - No inline handlers; Theme Store compliant
      ================================ */
   
   class AddToCartController {
     constructor(root) {
       this.root = root;
       if (!this.root || this.root.dataset.atcBound === '1') return;
       this.root.dataset.atcBound = '1';
   
       this.form = this.root.querySelector('form.atc__form');
       this.variantIdInput = this.root.querySelector('[data-variant-id]');
       this.addBtn = this.root.querySelector('[data-add-btn]');
       this.addBtnText = this.root.querySelector('[data-add-btn-text]');
       this.qtyInput = this.root.querySelector('.atc__qty-input');
       this.minus = this.root.querySelector('[data-qty-minus]');
       this.plus = this.root.querySelector('[data-qty-plus]');
       this.productJsonEl = this.root.querySelector('[data-product-json]');
       this.product = this.productJsonEl ? JSON.parse(this.productJsonEl.textContent) : null;
       this.sectionId = this.root.dataset.sectionId || null;
       this.currentVariant = null;
   
       this.moneyFormatEsc = this.root.dataset.moneyFormat || "${{amount}}";
       this.shopCurrency = (window.Shopify && Shopify.currency && Shopify.currency.active) || document.documentElement.getAttribute('data-shop-currency') || '';
   
       // Bind
       this.bindQty();
       this.bindOptions();
       this.bindSubmit();
       this.bindDialogs();
   
       // Init
       this.updateVariant();
       this.updateLegendSelected();
     }
   
     decodeEntities(str) {
       const el = document.createElement('textarea');
       el.innerHTML = str;
       return el.value;
     }
     formatMoneyHTML(cents, formatStr) {
       const value = Math.round(Number(cents) || 0);
       const fmt = formatStr || "${{amount}}";
       if (window.Shopify && typeof Shopify.formatMoney === 'function') {
         return Shopify.formatMoney(value, fmt);
       }
       const amount = value / 100;
       let out = fmt
         .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(amount).toString())
         .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.toFixed(2).replace('.', ','))
         .replace(/\{\{\s*amount\s*\}\}/g, amount.toFixed(2));
       if (!/\{\{.*\}\}/.test(fmt)) {
         try { out = new Intl.NumberFormat(undefined, { style: 'currency', currency: this.shopCurrency || 'USD' }).format(amount); }
         catch { out = `$${amount.toFixed(2)}`; }
       }
       return out;
     }
   
     clampQty(n) { return Math.max(1, parseInt(n || '1', 10) || 1); }
   
     get moneyFormat() { return this.decodeEntities(this.moneyFormatEsc); }
   
     bindQty() {
       if (!this.qtyInput) return;
       this.qtyInput.addEventListener('input', () => { this.qtyInput.value = this.clampQty(this.qtyInput.value); this.updateButtonTotal(); });
       this.qtyInput.addEventListener('change', () => { this.qtyInput.value = this.clampQty(this.qtyInput.value); this.updateButtonTotal(); });
       if (this.minus) this.minus.addEventListener('click', (e) => {
         e.preventDefault();
         e.stopImmediatePropagation();   // ← block other listeners on this element
         e.stopPropagation();            // ← block delegated document handlers
         this.qtyInput.value = Math.max(1, this.clampQty(this.qtyInput.value) - 1);
         this.qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
       });
   
       if (this.plus) this.plus.addEventListener('click', (e) => {
         e.preventDefault();
         e.stopImmediatePropagation();
         e.stopPropagation();
         this.qtyInput.value = this.clampQty(this.qtyInput.value) + 1;
         this.qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
       });
   
     }
   
     bindOptions() {
       this.root.addEventListener('change', (e) => {
         if (e.target.matches('[data-option-index]')) this.updateVariant();
       });
     }
   
     getSelectedOptions() {
       const radios = this.root.querySelectorAll('[data-option-index].atc__radio:checked');
       if (radios.length) {
         const byIdx = {};
         radios.forEach(r => { byIdx[r.dataset.optionIndex] = r.value; });
         return this.product?.options?.map((_, i) => byIdx[i]) || [];
       }
       const selects = Array.from(this.root.querySelectorAll('[data-option-index].atc__select'));
       if (selects.length) {
         const arr = selects.sort((a, b) => (+a.dataset.optionIndex) - (+b.dataset.optionIndex));
         return arr.map(s => s.value);
       }
       return [];
     }
   
     findVariant(opts) {
       if (!this.product) return null;
       return this.product.variants.find(v => v.options.every((opt, i) => opt === opts[i]));
     }
   
     updateLegendSelected() {
       if (!this.product) return;
       const selects = Array.from(this.root.querySelectorAll('[data-option-index].atc__select'));
       const radiosChecked = Array.from(this.root.querySelectorAll('[data-option-index].atc__radio:checked'));
       const byIdx = {};
       if (selects.length) selects.forEach(s => byIdx[+s.dataset.optionIndex] = s.value);
       if (radiosChecked.length) radiosChecked.forEach(r => byIdx[+r.dataset.optionIndex] = r.value);
       this.product.options.forEach((_, i) => {
         const el = this.root.querySelector(`.atc__legend-selected[data-selected-for="${i}"]`);
         if (el && byIdx[i] != null) el.textContent = byIdx[i];
       });
     }
   
     updateButtonTotal() {
       if (!this.priceEl || !this.product) return;
       const opts = this.getSelectedOptions();
       const v = this.findVariant(opts) || this.product.selected_or_first_available_variant || this.product.variants?.[0];
       if (!v || !v.available) { this.priceEl.innerHTML = ""; return; }
       const qty = this.qtyInput ? this.clampQty(this.qtyInput.value) : 1;
       const totalCents = Math.round((Number(v.price) || 0) * qty);
       this.priceEl.innerHTML = this.formatMoneyHTML(totalCents, this.moneyFormat);
     }
   
     updateVariant() {
       const opts = this.getSelectedOptions();
       const v = this.findVariant(opts);
       if (!v) return;
       if (this.variantIdInput) this.variantIdInput.value = v.id;
       if (this.addBtn) this.addBtn.disabled = !v.available;
       this.currentVariant = v;
       this.updateLegendSelected();
       this.updateButtonTotal();
       const detail = { variant: v, product: this.product };
       this.root.dispatchEvent(new CustomEvent('variant:change', { detail }));
       document.dispatchEvent(new CustomEvent('variant:change', { detail }));
     }
   
     bindSubmit() {
       if (!this.form) return;
       this.form.addEventListener('submit', async (ev) => {
         const sub = ev.submitter;
         // Let accelerated checkout pass through
         if (sub && (sub.classList?.contains('shopify-payment-button__button') || sub.closest?.('.shopify-payment-button'))) return;
   
         ev.preventDefault();
         if (!this.variantIdInput?.value || !this.addBtn) return;
   
         this.addBtn.setAttribute('aria-busy', 'true');
         this.addBtn.disabled = true;
         this.addBtnText?.setAttribute('aria-hidden', 'true');
   
          let cartRefreshPromise = null;
          try {
            const fd = new FormData(this.form);
            const qty = this.qtyInput ? this.clampQty(this.qtyInput.value) : 1;
            fd.set('quantity', String(qty));

            const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd });
            if (!res.ok) throw new Error('add_failed');

            cartRefreshPromise = window.__SplineCartQuantityState?.refresh?.();

            // Refresh cart drawer (if your theme provides it)
            try {
              const drawerRes = await fetch('/cart?view=drawer', { headers: { 'Accept': 'text/html' } });
              if (drawerRes.ok) {
               const html = await drawerRes.text();
               const doc = new DOMParser().parseFromString(html, 'text/html');
               const fresh = doc.getElementById('CartDrawerContents');
               const target = document.getElementById('CartDrawerContents');
               if (fresh && target) {
                 target.innerHTML = fresh.innerHTML;
                 if (typeof window.bindCartDrawerButtons === 'function') window.bindCartDrawerButtons();
               }
             }
           } catch { }
   
           // Open side panel cart (if exists)
           if (typeof window.openSidePanel === 'function') window.openSidePanel('cart');
   
         } catch (e) {
           console.error('Cart error:', e);
          } finally {
            this.addBtn.removeAttribute('aria-busy');
            this.addBtn.disabled = false;
            this.addBtnText?.removeAttribute('aria-hidden');
            if (cartRefreshPromise && typeof cartRefreshPromise.then === 'function') {
              try {
                await cartRefreshPromise;
              } catch (err) {
                console.error('Cart refresh failed', err);
              }
            }
            this.updateButtonTotal();
          }
        });
      }
   
     bindDialogs() {
       // Openers
       this.root.querySelectorAll('[data-modal-open]').forEach(btn => {
         if (btn.dataset.modalBound === '1') return;
         const id = btn.getAttribute('data-modal-open');
         const dlg = document.getElementById(id);
         if (!dlg || typeof dlg.showModal !== 'function') return;
         prepareSpDialog(dlg);
         btn.addEventListener('click', () => openSpDialog(dlg));
         btn.dataset.modalBound = '1';
       });
   
       if (!AddToCartController.modalCloseBound) {
         // Closers (delegated to document so multiple ATCs work)
         document.addEventListener('click', (e) => {
           const closeBtn = e.target.closest?.('.sp-dialog [data-modal-close]');
           if (!closeBtn) return;
           const dlg = closeBtn.closest('dialog');
           if (!dlg) return;
           e.preventDefault();
           closeSpDialog(dlg);
         });
         AddToCartController.modalCloseBound = true;
       }
   
       // Click outside to close (ensure each dialog binds once)
       document.querySelectorAll('dialog.sp-dialog').forEach(dlg => {
         if (dlg.dataset.modalOutsideBound === '1') return;
         prepareSpDialog(dlg);
         dlg.addEventListener('click', (e) => { if (e.target === dlg) closeSpDialog(dlg); });
         dlg.dataset.modalOutsideBound = '1';
       });
     }
   }
   
   const SP_DIALOG_ANIMATION_DURATION = 320;
   
   function shouldReduceMotion() {
     if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
     try {
       return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
     } catch {
       return false;
     }
   }
   
   function prepareSpDialog(dlg) {
     if (!dlg || dlg.dataset.modalAnimationBound === '1') return;
     dlg.dataset.modalAnimationBound = '1';
     dlg.addEventListener('cancel', (event) => {
       event.preventDefault();
       closeSpDialog(dlg);
     });
     dlg.addEventListener('close', () => {
       dlg.classList.remove('sp-dialog--visible');
       dlg.dataset.dialogAnimating = '';
     });
   }
   
   function openSpDialog(dlg) {
     if (!dlg || typeof dlg.showModal !== 'function') return;
     prepareSpDialog(dlg);
     if (dlg.open || dlg.dataset.dialogAnimating === 'closing') return;
     if (shouldReduceMotion()) {
       dlg.showModal();
       dlg.classList.add('sp-dialog--visible');
       dlg.dataset.dialogAnimating = '';
       return;
     }
     dlg.dataset.dialogAnimating = 'opening';
     dlg.showModal();
     requestAnimationFrame(() => {
       dlg.classList.add('sp-dialog--visible');
       if (dlg.dataset.dialogAnimating === 'opening') dlg.dataset.dialogAnimating = '';
     });
   }
   
   function closeSpDialog(dlg) {
     if (!dlg || !dlg.open) return;
     prepareSpDialog(dlg);
     if (shouldReduceMotion()) {
       dlg.dataset.dialogAnimating = '';
       dlg.classList.remove('sp-dialog--visible');
       dlg.close();
       return;
     }
     if (dlg.dataset.dialogAnimating === 'closing') return;
     dlg.dataset.dialogAnimating = 'closing';
     const onTransitionEnd = (event) => {
       if (event.target !== dlg || event.propertyName !== 'opacity') return;
       dlg.removeEventListener('transitionend', onTransitionEnd);
       dlg.dataset.dialogAnimating = '';
       dlg.close();
     };
     dlg.addEventListener('transitionend', onTransitionEnd);
     requestAnimationFrame(() => {
       dlg.classList.remove('sp-dialog--visible');
     });
     window.setTimeout(() => {
       if (!dlg.open) return;
       dlg.removeEventListener('transitionend', onTransitionEnd);
       dlg.dataset.dialogAnimating = '';
       dlg.close();
     }, SP_DIALOG_ANIMATION_DURATION);
   }
   
   /* Auto-init on load & after section renders in editor */
   function initATCContainers(ctx = document) {
     ctx.querySelectorAll('[data-atc-root]').forEach(node => new AddToCartController(node));
   }
   document.addEventListener('DOMContentLoaded', () => initATCContainers());
   document.addEventListener('shopify:section:load', (e) => initATCContainers(e.target));
   document.addEventListener('shopify:section:select', (e) => initATCContainers(e.target));
   
   /* Export if you need to manually call it elsewhere */
   window.initATCContainers = initATCContainers;
   
   /* ---------------------------------
      GLOBAL LIFECYCLE BINDINGS
      --------------------------------- */
   
   
   
   document.addEventListener('DOMContentLoaded', () => {
     // Core
     bindCarousels();
     bindFireSearch();
   
     // Product bits
    initShareContainers();
    initComplementaryBlocks();
    initProductGrids();
    initArticleGrids();
     bindHashtagCopy();
     bindProductAccordions();
     bindMobileSwipeMedia(document); // runs once on page load
     initSpCarousels();
   
     // ATC (bind any existing roots)
     window.bindAtcIn(document);
   });
   
   
   
   /* ================================
      Global Side Panel + Quick View
      (moved from section; no behavior changes)
      ================================ */
   (function () {
     const CONTENT_SEL = '#QuickViewContents[data-quick-view-body]';
   
     /* ---------- Quick View helpers ---------- */
     function openQuickPanel() {
       if (typeof openSidePanel === 'function') openSidePanel('quick');
       else console.warn('openSidePanel not found');
     }
   
     async function fetchQuickView(handle) {
       const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
       const preview = (window.Shopify && Shopify.theme && Shopify.theme.id)
         ? `&preview_theme_id=${Shopify.theme.id}`
         : '';
       const url = `${root}products/${encodeURIComponent(handle)}?view=quick-view${preview}`;
       const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
       if (!res.ok) {
         console.warn('Quick view URL failed', { url, status: res.status, statusText: res.statusText });
         throw new Error(`Quick view fetch failed: ${res.status}`);
       }
       return await res.text();
     }
   
   
   
     function bindQuickViewVariantSelection(container) {
       const form = container.querySelector('#QuickViewForm');
       if (!form) return;
   
       const groups = form.querySelectorAll('fieldset[id^="QuickView-Option-"]');
       const variantsNode = form.querySelector('script[type="application/json"][id^="QuickViewVariants"]');
       if (!variantsNode) return;
   
       const variants = JSON.parse(variantsNode.textContent || '[]');
       const idInput = form.querySelector('input[name="id"]');
       const submitBtn = form.querySelector('[type="submit"]');
   
       const currentSelection = () =>
         Array.from(groups).map(fs => fs.querySelector('input[type="radio"][name^="options["]:checked')?.value || '');
   
       function syncVariant() {
         const chosen = currentSelection();
         const match = variants.find(v => v.options.every((opt, i) => opt === chosen[i]));
         if (match) {
           if (idInput) idInput.value = match.id;
           if (submitBtn) submitBtn.disabled = !match.available;
         } else {
           if (submitBtn) submitBtn.disabled = true;
         }
       }
   
       form.addEventListener('change', (e) => {
         if (e.target.matches('input[type="radio"][name^="options["]')) syncVariant();
       });
   
       syncVariant();
     }
   
     function preselectQuickViewVariant(container, variantId) {
       if (!variantId) return;
       const form = container.querySelector('#QuickViewForm');
       const variantsNode = container.querySelector('script[type="application/json"][id^="QuickViewVariants"]');
       if (!form || !variantsNode) return;
   
       const variants = JSON.parse(variantsNode.textContent || '[]');
       const match = variants.find(v => String(v.id) === String(variantId));
       if (!match) return;
   
       const groups = form.querySelectorAll('fieldset[id^="QuickView-Option-"]');
       const qEsc = (val) => (window.CSS && CSS.escape ? CSS.escape(val) : val.replace(/(["\\])/g, '\\$1'));
   
       match.options.forEach((value, i) => {
         const group = groups[i];
         if (!group) return;
         const radio = group.querySelector(`input.option-input[value="${qEsc(value)}"]`);
         if (radio) {
           radio.checked = true;
           group.querySelector('.js-option-current')?.replaceChildren(document.createTextNode(value));
         }
       });
   
       const lastChecked = form.querySelector('input.option-input:checked');
       if (lastChecked) lastChecked.dispatchEvent(new Event('change', { bubbles: true }));
     }
   
    function injectQuickView(html, selectedVariantId) {
      const container = document.querySelector(CONTENT_SEL);
      if (!container) return;

      container.innerHTML = html;
      container.querySelectorAll('script').forEach((oldScript) => {
        const type = (oldScript.getAttribute('type') || '').trim();
        if (type && type !== 'text/javascript' && type !== 'module' && type !== '') {
          if (type.includes('json') || type === 'application/ld+json' || type === 'application/json') return;
        }
        const fresh = document.createElement('script');
        Array.from(oldScript.attributes).forEach((attr) => {
          fresh.setAttribute(attr.name, attr.value);
        });
        if (oldScript.src) {
          fresh.async = false;
          fresh.src = oldScript.src;
        } else {
          fresh.textContent = oldScript.textContent;
        }
        oldScript.replaceWith(fresh);
      });

      if (window.bindAtcIn) window.bindAtcIn(container);

      void container.offsetWidth;
      container.classList.add('fade-in');

       const form = container.querySelector('form[action="/cart/add"]');
       if (form) bindQuickViewVariantSelection(container);
       if (selectedVariantId) preselectQuickViewVariant(container, selectedVariantId);
   
       container.querySelectorAll('.product__image').forEach(img => {
         if (img.complete) img.classList.add('is-loaded');
         else {
           img.addEventListener('load', () => img.classList.add('is-loaded'), { once: true });
           img.addEventListener('error', () => img.classList.add('is-loaded'), { once: true });
         }
       });
   
       const firstFocusable = container.querySelector('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])');
       firstFocusable?.focus({ preventScroll: true });
     }
   
     document.addEventListener('click', async (e) => {
       const btn = e.target.closest('[data-action="quick-view"]');
       if (!btn) return;
   
       const handle = btn.getAttribute('data-product-handle');
       const variantId = btn.getAttribute('data-variant-id') || '';
       if (!handle) return;
   
       e.preventDefault();
   
       const container = document.querySelector(CONTENT_SEL);
       if (container) {
         container.innerHTML = '';
         container.classList.remove('fade-in');
       }
   
       openQuickPanel();
   
       try {
         const html = await fetchQuickView(handle);
         injectQuickView(html, variantId);
       } catch (err) {
         console.error(err);
         if (container) container.innerHTML = '<div style="padding:2rem;color:var(--color-error);">Failed to load quick view.</div>';
       }
     });
   
     /* ---------- Cart drawer controls ---------- */
     window.bindCartDrawerButtons = function bindCartDrawerButtons() {
       // Quantity buttons
       document.querySelectorAll('.cart-qty-btn').forEach(btn => {
         btn.onclick = () => {
           const key = btn.dataset.key;
           const action = btn.dataset.action;
           const wrapper = btn.closest('.cart-item');
           const qtyEl = wrapper?.querySelector('[data-qty]');
           let currentQty = parseInt(qtyEl?.textContent || '1', 10);
   
           if (action === 'increase') currentQty++;
           else if (action === 'decrease') currentQty = Math.max(currentQty - 1, 0);
   
           updateCartQuantity(key, currentQty);
         };
       });
   
       // Remove buttons
       document.querySelectorAll('.cart-remove').forEach(btn => {
         btn.onclick = () => updateCartQuantity(btn.dataset.remove, 0);
       });
   
       // Checkout
       document.getElementById('cart-checkout-btn')?.addEventListener('click', () => {
         window.location.href = "/checkout";
       });
   
       const noteField = document.querySelector('[data-cart-note]');
       if (noteField && !noteField.dataset.bound) {
         noteField.dataset.bound = '1';
         noteField.addEventListener('blur', () => updateCartNote(noteField.value));
       }
   
       document.querySelectorAll('[data-remove-discount]').forEach(btn => {
         if (btn.dataset.bound) return;
         btn.dataset.bound = '1';
         btn.addEventListener('click', async () => {
           const code = btn.dataset.removeDiscount;
           if (!code) return;
           beginCartDrawerBusy();
           btn.disabled = true;
           try {
             await fetch(`/discounts/${encodeURIComponent(code)}?remove=1`, {
               method: 'GET',
               headers: { 'Accept': 'text/html' }
             });
           } catch (error) {
             console.error('Failed to remove discount', error);
           } finally {
             try {
               await reloadCartDrawerContents();
             } finally {
               endCartDrawerBusy();
             }
           }
         });
       });
   
     };
   
    async function updateCartQuantity(key, quantity) {
      if (!key) return;

      beginCartDrawerBusy();

      const itemEl = document.querySelector(`[data-key="${key}"]`);
      itemEl?.classList.add("loading");

      try {
        const res = await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ id: key, quantity })
        });
   
         let payload = {};
         try { payload = await res.json(); } catch (_) { payload = {}; }
         if (!res.ok) throw new Error(payload?.description || "Cart update failed");
   
        const cart = payload; // updated cart

        window.__SplineCartQuantityState?.applyCart?.(cart);

        const countEl = document.querySelector('[data-cart-count]');
        if (countEl) countEl.textContent = cart.item_count;
   
         const drawerHeader = document.querySelector('.cart-drawer-header h3');
         if (drawerHeader) {
           drawerHeader.innerHTML = `${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`;
         }
   
         if (cart.item_count === 0) {
           itemEl?.remove();
         }
   
         await reloadCartDrawerContents();
      } catch (e) {
        console.error(e);
        alert("There was a problem updating your cart.");
      } finally {
        itemEl?.classList.remove("loading");
        endCartDrawerBusy();
      }
    }
   
    async function updateCartNote(note) {
      beginCartDrawerBusy();
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ note })
        });
        await reloadCartDrawerContents();
      } catch (error) {
        console.error('Failed to update cart note', error);
      } finally {
        endCartDrawerBusy();
      }
    }
   
     const clampProgressValue = (value) => {
       const numeric = parseFloat(value);
       if (!Number.isFinite(numeric)) return 0;
       return Math.min(100, Math.max(0, numeric));
     };
   
     const getShippingProgressFromContainer = (container) => {
       if (!container) return 0;
       const bar = container.querySelector?.('[data-shipping-progress]');
       if (!bar) return 0;
       if (bar.dataset.shippingProgressCurrent) return clampProgressValue(bar.dataset.shippingProgressCurrent);
       if (bar.dataset.shippingProgress) return clampProgressValue(bar.dataset.shippingProgress);
       if (bar.style.width) return clampProgressValue(bar.style.width);
       return 0;
     };
   
     const animateCartShippingBar = (container, startOverride = null) => {
       const scope = container instanceof Element ? container : document;
       const bars = scope?.querySelectorAll?.('[data-shipping-progress]');
       if (!bars || !bars.length) return;
   
       bars.forEach((bar) => {
         const target = clampProgressValue(bar.dataset.shippingProgress);
         const startValue = startOverride !== null && startOverride !== undefined
           ? clampProgressValue(startOverride)
           : clampProgressValue(bar.dataset.shippingProgressCurrent ?? target);
   
         const gradientStart = bar.dataset.gradientStart;
         const gradientEnd = bar.dataset.gradientEnd;
         if (gradientStart) bar.style.setProperty('--shipping-gradient-start', gradientStart);
         if (gradientEnd) bar.style.setProperty('--shipping-gradient-end', gradientEnd);
   
         const previousTransition = bar.style.transition;
         bar.style.transition = 'none';
         bar.style.width = `${startValue}%`;
         bar.dataset.shippingProgressCurrent = startValue;
         void bar.offsetWidth;
         bar.style.transition = previousTransition || '';
   
         requestAnimationFrame(() => {
           requestAnimationFrame(() => {
             bar.style.width = `${target}%`;
             bar.dataset.shippingProgressCurrent = target;
           });
         });
       });
     };
   
    window.animateCartShippingBar = animateCartShippingBar;

    let cartDrawerBusyDepth = 0;

    function syncCartDrawerBusyState() {
      const container = document.getElementById('cart-drawer-content');
      if (!container) return;
      if (cartDrawerBusyDepth > 0) {
        container.classList.add('is-busy');
        container.setAttribute('aria-busy', 'true');
      } else {
        container.classList.remove('is-busy');
        container.removeAttribute('aria-busy');
      }
    }

    function beginCartDrawerBusy() {
      cartDrawerBusyDepth += 1;
      syncCartDrawerBusyState();
    }

    function endCartDrawerBusy() {
      cartDrawerBusyDepth = Math.max(0, cartDrawerBusyDepth - 1);
      syncCartDrawerBusyState();
    }


    async function reloadCartDrawerContents() {
      beginCartDrawerBusy();
      try {
        const res = await fetch('/cart?view=drawer');
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
   
         // Your drawer uses #cart-drawer-content (lowercase)
         const newContents = doc.getElementById("cart-drawer-content");
         const currentContainer = document.getElementById("cart-drawer-content");
         const previousProgress = getShippingProgressFromContainer(currentContainer);
   
         if (newContents && currentContainer) {
           currentContainer.innerHTML = newContents.innerHTML;
           bindCartDrawerButtons();
           initCartNoteCollapsible(currentContainer);
           animateCartShippingBar(currentContainer, previousProgress);
   
           const fadeTarget = currentContainer.querySelector('[data-cart-fade]');
           const isEmpty = !doc.querySelector('[data-key]');
   
           if (fadeTarget) {
             fadeTarget.classList.toggle('no-animation', !isEmpty);
             fadeTarget.classList.add('is-visible');
             if (!isEmpty) setTimeout(() => fadeTarget.classList.remove('no-animation'), 10);
           }
   
           const emptyMessage = currentContainer.querySelector('[data-empty-message]');
           if (emptyMessage) {
             requestAnimationFrame(() => emptyMessage.classList.add('visible'));
           }
         }
      } catch (error) {
        console.error('Failed to reload cart drawer:', error);
      } finally {
        endCartDrawerBusy();
      }
    }
   
     /* ---------- Side panel wiring ---------- */
     document.addEventListener("DOMContentLoaded", () => {
       bindCartDrawerButtons();
   
       let isDrawerLoading = false;
   
       const getSidePanel = () => document.getElementById("global-side-panel");
       const getSidePanelBody = () => document.getElementById("side-panel-dynamic-body");
   
       const assignTriggerAttributes = (btn) => {
         if (!btn) return;
         btn.setAttribute('aria-controls', 'global-side-panel');
         btn.setAttribute('aria-haspopup', 'dialog');
         if (!btn.hasAttribute('aria-expanded')) btn.setAttribute('aria-expanded', 'false');
       };

       const applyDrawerColorScheme = (container) => {
         if (!container) return;
         const scheme = container.dataset.drawerColorScheme;
         if (!scheme) return;
         container.querySelectorAll('.menu-drawer.color-scheme').forEach((drawer) => {
           const removable = Array.from(drawer.classList).filter((cls) => cls.startsWith('color-') && cls !== 'color-scheme');
           removable.forEach((cls) => drawer.classList.remove(cls));
           drawer.classList.add(`color-${scheme}`);
         });
       };
   
       const mountHeaderMenuToDrawer = () => {
         const placeholder = document.querySelector('[data-panel="menu"] [data-menu-container]');
         const template = document.querySelector('template[data-header-menu-template]');
         if (!placeholder || !template) return;
         const markup = template.innerHTML.trim();
         if (!markup) return;
         if (placeholder.dataset.templateSignature === markup) return;
         placeholder.dataset.templateSignature = markup;
         placeholder.innerHTML = markup;
         applyDrawerColorScheme(placeholder);
         placeholder.querySelectorAll('script').forEach((oldScript) => {
           const fresh = document.createElement('script');
           if (oldScript.src) {
             fresh.src = oldScript.src;
           } else {
             fresh.textContent = oldScript.textContent;
           }
           Array.from(oldScript.attributes).forEach(attr => {
             fresh.setAttribute(attr.name, attr.value);
           });
           oldScript.replaceWith(fresh);
         });
       };
   
       const collectFocusableElements = (panel) => {
         if (!panel) return [];
         const nodes = Array.from(panel.querySelectorAll(SIDE_PANEL_FOCUSABLE_SELECTOR));
         return nodes.filter((el) => {
           if (el.hasAttribute('disabled')) return false;
           if (el.getAttribute('aria-hidden') === 'true') return false;
           if (el.closest('[hidden]')) return false;
           const style = window.getComputedStyle(el);
           if (style.display === 'none' || style.visibility === 'hidden') return false;
           return true;
         });
       };
   
       const focusFirstElement = (panel) => {
         const target = sidePanelFocusables.find((el) => {
           const rect = el.getBoundingClientRect();
           return rect.width > 0 && rect.height > 0;
         }) || sidePanelFocusables[0] || panel;
         if (target && typeof target.focus === 'function') {
           target.focus({ preventScroll: true });
         }
       };
   
       const applyFocusTrap = (panel) => {
         if (!panel) return;
         releaseFocusTrap(panel);
         sidePanelFocusables = collectFocusableElements(panel);
         if (!sidePanelFocusables.length) {
           panel.setAttribute('tabindex', '-1');
           sidePanelFocusables = [panel];
         } else {
           panel.removeAttribute('tabindex');
         }
         sidePanelTrapHandler = (event) => {
           if (event.key !== 'Tab' || sidePanelFocusables.length === 0) return;
           const first = sidePanelFocusables[0];
           const last = sidePanelFocusables[sidePanelFocusables.length - 1];
           const active = document.activeElement;
           if (event.shiftKey) {
             if (active === first || !panel.contains(active)) {
               event.preventDefault();
               (last || first)?.focus({ preventScroll: true });
             }
           } else if (active === last) {
             event.preventDefault();
             first?.focus({ preventScroll: true });
           }
         };
         panel.addEventListener('keydown', sidePanelTrapHandler);
         requestAnimationFrame(() => focusFirstElement(panel));
       };
   
       function releaseFocusTrap(panel) {
         if (panel && sidePanelTrapHandler) {
           panel.removeEventListener('keydown', sidePanelTrapHandler);
         }
         sidePanelTrapHandler = null;
         sidePanelFocusables = [];
         if (panel && panel.getAttribute('tabindex') === '-1') {
           panel.removeAttribute('tabindex');
         }
       }
   
       mountHeaderMenuToDrawer();
   
       document.addEventListener('shopify:section:load', (event) => {
         const target = event?.target;
         if (!target) return;
         if (target.querySelector('template[data-header-menu-template]') || target.querySelector('[data-panel="menu"] [data-menu-container]')) {
           mountHeaderMenuToDrawer();
         }
         bindPanelTriggers(target);
       });
   
       document.addEventListener('shopify:section:select', (event) => {
         const target = event?.target;
         if (target) {
           bindPanelTriggers(target);
         }
       });
   
       const panelTriggers = [
         { selector: "[data-open-cart],[data-open-panel=\"cart\"]", type: "cart", loader: true },
         { selector: "[data-open-search],[data-open-panel=\"search\"]", type: "search" },
         { selector: "[data-open-menu],[data-open-panel=\"menu\"]", type: "menu" },
         { selector: "[data-open-filters],[data-open-panel=\"filters\"]", type: "filters" },
         { selector: "[data-open-password],[data-open-panel=\"password\"]", type: "password" }
       ];
   
       const bindPanelTriggers = (scope = document) => {
         panelTriggers.forEach(({ selector, type, loader }) => {
           scope.querySelectorAll(selector).forEach((btn) => {
             if (btn.dataset.sidePanelBound === '1') return;
             btn.dataset.sidePanelBound = '1';
             assignTriggerAttributes(btn);
             btn.addEventListener('click', async (event) => {
               event.preventDefault();
               if (loader && isDrawerLoading) return;
               if (loader) isDrawerLoading = true;
               try {
                 openSidePanel(type, btn);
                 if (loader) {
                   await reloadCartDrawerContents();
                 }
               } finally {
                 if (loader) isDrawerLoading = false;
               }
             });
           });
         });
       };
   
       bindPanelTriggers();
   
       // Close on overlay button
       document.addEventListener("click", (e) => {
         if (e.target.closest("[data-close-panel]")) {
           e.preventDefault();
           closeSidePanel();
         }
       });
   
       // Close on Escape
       document.addEventListener("keydown", (e) => {
         if (e.key === "Escape") {
           const panel = getSidePanel();
           if (panel?.classList.contains("is-visible")) {
             e.preventDefault();
             closeSidePanel();
           }
         }
       });
   
       function closeSidePanel() {
         const panel = getSidePanel();
         if (!panel || !panel.classList.contains("is-visible")) return;
   
         const content = panel.querySelector(".side-panel-content");
         panel.querySelector('[data-empty-message]')?.classList.remove('visible');
   
        if (panel.dataset.activePanel === 'menu') {
          const stack = panel.querySelector('[data-panel="menu"] .menu-stack');
          stack?.classList.remove('is-mounted');
          const menuFade = panel.querySelector('[data-panel="menu"] [data-menu-fade]');
          menuFade?.classList.remove('is-visible');
          const menuRoot = panel.querySelector('[data-panel="menu"] #menu-drawer-content');
          if (menuRoot) {
            menuRoot.classList.remove('md-direction-back');
            menuRoot.classList.remove('md-direction-forward');
          }
        }
   
         const trigger = sidePanelCurrentTrigger;
         if (trigger && trigger.setAttribute) trigger.setAttribute('aria-expanded', 'false');
   
         panel.setAttribute('aria-hidden', 'true');
         releaseFocusTrap(panel);
         document.body.classList.remove("no-scroll");
         panel.classList.remove("is-visible");
         content.classList.add("is-closing");
   
         setTimeout(() => {
           panel.style.display = "none";
           content.classList.remove("is-closing");
           const focusTarget = trigger || sidePanelLastActiveElement;
           if (focusTarget && typeof focusTarget.focus === 'function') {
             focusTarget.focus({ preventScroll: true });
           }
           sidePanelCurrentTrigger = null;
           sidePanelLastActiveElement = null;
         }, 500);
       }
   
       // Global opener
       window.openSidePanel = function (type = "custom", trigger = null) {
         const panel = getSidePanel();
         const body = getSidePanelBody();
         if (!panel || !body) return;
         const content = panel.querySelector(".side-panel-content");
         const fadeTarget = document.querySelector('[data-cart-fade]');
   
         if (trigger) {
           if (sidePanelCurrentTrigger && sidePanelCurrentTrigger !== trigger && sidePanelCurrentTrigger.setAttribute) {
             sidePanelCurrentTrigger.setAttribute('aria-expanded', 'false');
           }
           sidePanelCurrentTrigger = trigger;
         } else {
           const activeEl = document.activeElement;
           if (activeEl && activeEl !== document.body) {
             if (sidePanelCurrentTrigger && sidePanelCurrentTrigger !== activeEl && sidePanelCurrentTrigger.setAttribute) {
               sidePanelCurrentTrigger.setAttribute('aria-expanded', 'false');
             }
             sidePanelCurrentTrigger = activeEl;
           }
         }
         sidePanelLastActiveElement = sidePanelCurrentTrigger;
         if (sidePanelCurrentTrigger && sidePanelCurrentTrigger.setAttribute) {
           sidePanelCurrentTrigger.setAttribute('aria-expanded', 'true');
         }
   
         const sideByPanel = { cart: 'right', search: 'right', menu: 'left', quick: 'right', password: 'right', filters: 'left', pickup: 'right' };
         content.setAttribute('data-side', sideByPanel[type] || 'right');
   
         if (type === 'cart' && fadeTarget) {
           fadeTarget.classList.remove('is-visible', 'no-animation');
           setTimeout(() => fadeTarget.classList.add('is-visible'), 10);
         }
   
         const wasVisible = panel.classList.contains("is-visible");
   
         body.querySelectorAll(".panel-view").forEach(v => v.style.display = "none");
         const view = body.querySelector(`[data-panel="${type}"]`);
         if (view) view.style.display = "block";
         panel.dataset.activePanel = type;
         if (type === 'cart') {
           requestAnimationFrame(() => animateCartShippingBar(document.getElementById('cart-drawer-content'), 0));
         }
   
         if (!wasVisible) {
           content.classList.remove("is-closing");
           document.body.classList.add("no-scroll");
           panel.style.display = "block";
           panel.setAttribute('aria-hidden', 'false');
           requestAnimationFrame(() => {
             panel.classList.add("is-visible");
           });
         } else {
           panel.setAttribute('aria-hidden', 'false');
         }
   
        if (type === 'menu') {
          const stack = panel.querySelector('[data-panel="menu"] .menu-stack');
          const menuRoot = panel.querySelector('[data-panel="menu"] #menu-drawer-content');
          if (menuRoot) {
            menuRoot.classList.remove('md-direction-back');
            menuRoot.classList.add('md-direction-forward');
          }
          if (stack) {
            stack.classList.remove('is-mounted');
            requestAnimationFrame(() => {
              requestAnimationFrame(() => stack.classList.add('is-mounted'));
            });
           }
           const menuFade = panel.querySelector('[data-panel="menu"] [data-menu-fade]');
           if (menuFade) {
             menuFade.classList.remove('is-visible');
             void menuFade.offsetWidth;
             requestAnimationFrame(() => {
               requestAnimationFrame(() => menuFade.classList.add('is-visible'));
             });
           }
         }
   
         const focusSetup = () => applyFocusTrap(panel);
         if (!wasVisible) {
           requestAnimationFrame(() => requestAnimationFrame(focusSetup));
         } else {
           requestAnimationFrame(focusSetup);
         }
       };
   
       // expose for modules needing manual close
       window.closeSidePanel = closeSidePanel;
     });
   
     // Minimal formatter if missing
     if (!window.Shopify) window.Shopify = {};
     if (typeof Shopify.formatMoney !== 'function') {
       Shopify.formatMoney = function (cents) {
         try {
           const currency =
             (window.Shopify && Shopify.currency && Shopify.currency.active) ||
             document.documentElement.getAttribute('data-shop-currency') || 'USD';
           const value = (Number(cents) / 100) || 0;
           return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(value);
         } catch {
           const value = (Number(cents) / 100).toFixed(2);
           return `$${value}`;
         }
       };
     }
   })();
   
   
   /* =========================================
      Quotes with Logos (Tabbed)
      ========================================= */
   (function () {
     const SELECTOR = '[data-section-type="quotes-logos"]';
     const BOUND = 'qlBound';
   
     function initQuotesLogos(section) {
       const root = section.matches?.(SELECTOR) ? section : section.querySelector?.(SELECTOR);
       if (!root || root.dataset[BOUND] === '1') return;
       root.dataset[BOUND] = '1';
   
       const tabs = Array.from(root.querySelectorAll('.ql__logo-btn'));
       const panels = Array.from(root.querySelectorAll('.ql__quote'));
       if (!tabs.length || !panels.length) return;
   
       let active = Math.max(0, tabs.findIndex(t => t.classList.contains('is-active')));
       if (active < 0) active = 0;
   
       const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
   
       function showPanel(currIdx, nextIdx) {
         const currentPanel = panels[currIdx];
         const nextPanel = panels[nextIdx];
   
         if (reduced) {
           currentPanel.classList.remove('anim-in', 'anim-out', 'is-active');
           currentPanel.hidden = true;
           currentPanel.classList.add('is-hidden');
   
           nextPanel.hidden = false;
           nextPanel.classList.remove('is-hidden', 'anim-in', 'anim-out');
           nextPanel.classList.add('is-active');
           return;
         }
   
         currentPanel.classList.remove('anim-in');
         currentPanel.classList.add('anim-out');
   
         const onOut = () => {
           currentPanel.classList.remove('anim-out', 'is-active');
           currentPanel.hidden = true;
           currentPanel.classList.add('is-hidden');
   
           nextPanel.hidden = false;
           nextPanel.classList.remove('is-hidden', 'anim-out');
           nextPanel.classList.add('is-active', 'anim-in');
           nextPanel.addEventListener('animationend', () => nextPanel.classList.remove('anim-in'), { once: true });
         };
   
         currentPanel.addEventListener('animationend', onOut, { once: true });
       }
   
       function setActive(next) {
         if (next === active || next < 0 || next >= tabs.length) return;
   
         const currTab = tabs[active];
         const nextTab = tabs[next];
   
         // Tabs ARIA/state
         currTab.classList.remove('is-active');
         currTab.setAttribute('aria-selected', 'false');
         currTab.setAttribute('tabindex', '-1');
   
         nextTab.classList.add('is-active');
         nextTab.setAttribute('aria-selected', 'true');
         nextTab.setAttribute('tabindex', '0');
         nextTab.focus({ preventScroll: true });
   
         // Panels
         showPanel(active, next);
         active = next;
       }
   
       // Delegated click (single listener per section)
       const onClick = (e) => {
         const btn = e.target.closest('.ql__logo-btn');
         if (!btn || !root.contains(btn)) return;
         e.preventDefault();
         const idx = tabs.indexOf(btn);
         if (idx !== -1) setActive(idx);
       };
   
       // Keyboard – Left/Right/Home/End, RTL-aware
       const onKey = (e) => {
         if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
         const dir = getComputedStyle(document.documentElement).direction === 'rtl' ? -1 : 1;
         let next = active;
         if (e.key === 'ArrowRight') next = active + (1 * dir);
         if (e.key === 'ArrowLeft') next = active - (1 * dir);
         if (e.key === 'Home') next = 0;
         if (e.key === 'End') next = tabs.length - 1;
         next = Math.max(0, Math.min(next, tabs.length - 1));
         setActive(next);
         e.preventDefault();
       };
   
       root.addEventListener('click', onClick);
       root.addEventListener('keydown', onKey);
   
       // Unbind for Theme Editor
       root.__ql_unbind__ = () => {
         root.removeEventListener('click', onClick);
         root.removeEventListener('keydown', onKey);
         delete root.dataset[BOUND];
         delete root.__ql_unbind__;
       };
     }
   
     function destroyQuotesLogos(section) {
       const root = section.matches?.(SELECTOR) ? section : section.querySelector?.(SELECTOR);
       root?.__ql_unbind__?.();
     }
   
     // Auto-bind on load
     document.addEventListener('DOMContentLoaded', () => {
       document.querySelectorAll(SELECTOR).forEach(initQuotesLogos);
     });
   
     // Theme Editor lifecycle
     document.addEventListener('shopify:section:load', (e) => initQuotesLogos(e.target));
     document.addEventListener('shopify:section:unload', (e) => destroyQuotesLogos(e.target));
   
     // Optional export
     window.initQuotesLogos = initQuotesLogos;
   })();
   
   function initReadMore(root) {
     if (!root) return;
     const toggleBtn = root.querySelector('[data-toggle]');
     const wrapper = root.querySelector('[data-wrapper]');
     const content = root.querySelector('[data-content]');
     if (!content) return;
   
     const moreLabel = toggleBtn?.dataset.readmoreMore || window.theme?.strings?.readMore || "Read more";
     const lessLabel = toggleBtn?.dataset.readmoreLess || window.theme?.strings?.readLess || "Read less";
     let expanded = false;
   
     const limitAttr = Number(root.dataset.readmoreLimit || 0);
     if (Number.isFinite(limitAttr) && limitAttr > 0 && toggleBtn) {
       const originalHtml = content.innerHTML;
       const plainText = content.textContent.trim();
       if (plainText.length <= limitAttr) {
         toggleBtn.remove();
         root.classList.add('no-toggle');
         return;
       }
   
       const ellipsis = root.dataset.readmoreEllipsis || "…";
       const truncatedText = plainText.slice(0, limitAttr).replace(/\s+$/, "");
       const truncatedDisplay = truncatedText + ellipsis;
   
       content.dataset.fullHtml = originalHtml;
       content.dataset.truncatedHtml = truncatedDisplay;
       content.textContent = truncatedDisplay;
       toggleBtn.textContent = moreLabel;
   
       toggleBtn.addEventListener('click', () => {
         expanded = !expanded;
         root.classList.toggle('is-expanded', expanded);
         toggleBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
   
         if (expanded) {
           content.innerHTML = content.dataset.fullHtml || originalHtml;
           toggleBtn.textContent = lessLabel;
         } else {
           content.textContent = content.dataset.truncatedHtml || truncatedDisplay;
           toggleBtn.textContent = moreLabel;
         }
       });
   
       return;
     }
   
     if (!wrapper || !toggleBtn) return;
   
     const lineHeight = parseFloat(getComputedStyle(content).lineHeight) || 24;
     const collapsedHeight = lineHeight * 5;
   
     if (content.scrollHeight <= collapsedHeight + lineHeight) {
       root.classList.add('no-toggle');
       toggleBtn.remove();
       return;
     }
   
     wrapper.style.maxHeight = collapsedHeight + "px";
     toggleBtn.textContent = moreLabel;
   
     const adjustMaxHeight = () => {
       if (expanded) {
         wrapper.style.maxHeight = wrapper.scrollHeight + "px";
       } else {
         wrapper.style.maxHeight = collapsedHeight + "px";
       }
     };
   
     toggleBtn.addEventListener('click', () => {
       expanded = !expanded;
       root.classList.toggle('is-expanded', expanded);
       toggleBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
       adjustMaxHeight();
       toggleBtn.textContent = expanded ? lessLabel : moreLabel;
     });
   
     window.addEventListener('resize', adjustMaxHeight);
   }
   
   // Auto-init all read-more blocks
   document.addEventListener('DOMContentLoaded', () => {
     document.querySelectorAll('[data-readmore]').forEach(initReadMore);
   });
   document.addEventListener('DOMContentLoaded', () => {
     const btn = document.getElementById('backToTopBtn');
     if (!btn) return;
   
     window.addEventListener('scroll', () => {
       if (window.scrollY > 200) {
         btn.classList.add('visible');
       } else {
         btn.classList.remove('visible');
       }
     });
   
     btn.addEventListener('click', () => {
       const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
       window.scrollTo({ top: 0, behavior: prefersReduced ? 'auto' : 'smooth' });
     });
   });
   function initAccordions(root = document) {
     root.querySelectorAll('.accordion').forEach((btn) => {
       const panel = root.getElementById(btn.getAttribute('aria-controls'));
       if (!panel) return;
   
       btn.addEventListener('click', () => {
         const isOpen = btn.getAttribute('aria-expanded') === 'true';
   
         btn.setAttribute('aria-expanded', String(!isOpen));
         btn.classList.toggle('active', !isOpen);
   
         if (isOpen) {
           // close
           panel.style.maxHeight = panel.scrollHeight + 'px'; // lock height
           requestAnimationFrame(() => { panel.style.maxHeight = '0px'; });
           panel.addEventListener('transitionend', function onEnd() {
             if (btn.getAttribute('aria-expanded') === 'false') panel.hidden = true;
             panel.removeEventListener('transitionend', onEnd);
           });
         } else {
           // open
           panel.hidden = false;
           panel.style.maxHeight = panel.scrollHeight + 'px';
         }
       });
     });
   }
   
   document.addEventListener('DOMContentLoaded', () => initAccordions(document));
   
   // Shopify editor support
   document.addEventListener('shopify:section:load', (e) => initAccordions(e.target));
   
   
   
   
   function initCountdownBlocks(root = document) {
     root.querySelectorAll('.countdown-inner').forEach((el) => {
       const deadline = new Date(el.dataset.deadline).getTime();
       if (isNaN(deadline)) return;
   
       const box = el.closest('.countdown-timer');
       const expiredEl = box ? box.querySelector('.countdown-expired') : null;
       const daysTarget = el.querySelector('[data-days]');
       const hoursTarget = el.querySelector('[data-hours]');
       const minutesTarget = el.querySelector('[data-minutes]');
       const secondsTarget = el.querySelector('[data-seconds]');
   
       if (!daysTarget || !hoursTarget || !minutesTarget || !secondsTarget) return;
   
       function tick() {
         const now = Date.now();
         const diff = deadline - now;
   
         if (diff <= 0) {
           el.hidden = true;
           if (expiredEl) expiredEl.hidden = false;
           if (box && box.dataset.hide === "true") {
             box.style.display = "none";
           }
           clearInterval(intv);
           return;
         }
   
         const d = Math.floor(diff / (1000 * 60 * 60 * 24));
         const h = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
         const m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
         const s = Math.floor((diff % (1000 * 60)) / 1000);
   
         daysTarget.textContent = d;
         hoursTarget.textContent = ('0' + h).slice(-2);
         minutesTarget.textContent = ('0' + m).slice(-2);
         secondsTarget.textContent = ('0' + s).slice(-2);
       }
   
       tick();
       const intv = setInterval(tick, 1000);
     });
   }
   
   document.addEventListener('DOMContentLoaded', () => initCountdownBlocks(document));
   document.addEventListener('shopify:section:load', (e) => initCountdownBlocks(e.target));
   
   
   function initDataCountdowns(scope = document) {
     const root = scope && typeof scope.querySelectorAll === 'function' ? scope : document;
     root.querySelectorAll('[data-countdown]').forEach((el) => {
       const targetAttr = el.getAttribute('data-target') || el.dataset.target;
       const endISO = targetAttr || el.getAttribute('data-countdown') || el.dataset.countdown;
       if (!endISO) return;
   
       if (el.dataset.bound === '1') return;
       el.dataset.bound = '1';
   
       const endTextEl = el.querySelector('[data-end-text]');
       if (endTextEl) endTextEl.textContent = endISO;
   
       const targetTime = Date.parse(endISO);
       if (!Number.isFinite(targetTime)) {
         const timerWrapInvalid = el.querySelector('.countdown-timer');
         if (timerWrapInvalid) timerWrapInvalid.textContent = '—';
         return;
       }
   
       const hideOnComplete = (el.getAttribute('data-hide-complete') || '').toString() === 'true';
   
       const altSelector = (name) => el.querySelector(`[data-cd="${name}"]`);
       const defaultSelectors = {
         days: el.querySelector('[data-days]'),
         hours: el.querySelector('[data-hours]'),
         mins: el.querySelector('[data-mins]'),
         secs: el.querySelector('[data-secs]')
       };
       const usingAltSelectors = !defaultSelectors.days && !!altSelector('days');
       const daysEl = usingAltSelectors ? altSelector('days') : defaultSelectors.days;
       const hoursEl = usingAltSelectors ? altSelector('hours') : defaultSelectors.hours;
       const minsEl = usingAltSelectors ? altSelector('minutes') : defaultSelectors.mins;
       const secsEl = usingAltSelectors ? altSelector('seconds') : defaultSelectors.secs;
       if (!daysEl || !hoursEl || !minsEl) return;
   
       const timerWrap = el.querySelector('.countdown-timer') || el;
       const pad = (value) => String(value).padStart(2, '0');
   
       const render = () => {
         const now = Date.now();
         let diff = targetTime - now;
         if (diff <= 0) {
           if (hideOnComplete) {
             timerWrap.style.display = 'none';
           } else {
             daysEl.textContent = '00';
             hoursEl.textContent = '00';
             minsEl.textContent = '00';
             if (secsEl) secsEl.textContent = '00';
           }
           return true;
         }
   
         diff = Math.max(0, diff);
         const days = Math.floor(diff / 86400000); diff -= days * 86400000;
         const hours = Math.floor(diff / 3600000); diff -= hours * 3600000;
         const mins = Math.floor(diff / 60000); diff -= mins * 60000;
         const secs = Math.floor(diff / 1000);
   
         daysEl.textContent = pad(days);
         hoursEl.textContent = pad(hours);
         minsEl.textContent = pad(mins);
         if (secsEl) secsEl.textContent = pad(secs);
         return false;
       };
   
       if (!render()) {
         const interval = setInterval(() => {
           if (render()) clearInterval(interval);
         }, 1000);
       }
     });
   }
   
   const initDataCountdownsHandlers = (scope) => initDataCountdowns(scope);
   document.addEventListener('DOMContentLoaded', () => initDataCountdownsHandlers());
   document.addEventListener('shopify:section:load', (e) => initDataCountdownsHandlers(e.target));
   document.addEventListener('shopify:block:select', (e) => initDataCountdownsHandlers(e.target));
   function bindCarousels(scope = document) {
     const root = scope && typeof scope.querySelectorAll === 'function' ? scope : document;
     root.querySelectorAll('.columns-section').forEach((section) => {
       const isDesktopSlider = section.classList.contains('columns--slider-desktop');
       const isMobileSlider = section.classList.contains('columns--slider-mobile');
       if (!isDesktopSlider && !isMobileSlider) return;
   
       const scroller = section.querySelector('.columns-wrapper');
       const prevBtn = section.querySelector('.columns-slider-prev');
       const nextBtn = section.querySelector('.columns-slider-next');
       if (!scroller || !prevBtn || !nextBtn) return;
   
       const page = () => scroller.clientWidth || 1;
   
       const updateDisabled = () => {
         const max = Math.max(0, scroller.scrollWidth - scroller.clientWidth - 1);
         prevBtn.classList.toggle('is-disabled', scroller.scrollLeft <= 0);
         nextBtn.classList.toggle('is-disabled', scroller.scrollLeft >= max);
       };
   
       const scrollPage = (dir) => {
         scroller.scrollBy({ left: dir * page(), behavior: 'smooth' });
       };
   
       if (!prevBtn.dataset.bound) {
         prevBtn.dataset.bound = '1';
         prevBtn.addEventListener('click', () => scrollPage(-1));
       }
       if (!nextBtn.dataset.bound) {
         nextBtn.dataset.bound = '1';
         nextBtn.addEventListener('click', () => scrollPage(1));
       }
   
       if (!scroller.dataset.bound) {
         scroller.dataset.bound = '1';
         scroller.addEventListener('scroll', updateDisabled, { passive: true });
         window.addEventListener('resize', updateDisabled);
       }
   
       updateDisabled();
     });
   }
   
   document.addEventListener('DOMContentLoaded', () => bindCarousels());
   document.addEventListener('shopify:section:load', (event) => bindCarousels(event.target));
   
   function initSpCarousels(scope = document) {
     // legacy hook placeholder for older sections using initSpCarousels.
     bindCarousels(scope);
   }
   
   const CART_NOTE_STORAGE_PREFIX = 'cart-note:';
   let cartNoteStorageTested = false;
   let cartNoteStorageEnabled = false;
   
   function cartNoteStorageAvailable() {
     if (cartNoteStorageTested) return cartNoteStorageEnabled;
     cartNoteStorageTested = true;
     try {
       if (typeof window === 'undefined' || !window.sessionStorage) {
         cartNoteStorageEnabled = false;
       } else {
         const testKey = `${CART_NOTE_STORAGE_PREFIX}test`;
         window.sessionStorage.setItem(testKey, '1');
         window.sessionStorage.removeItem(testKey);
         cartNoteStorageEnabled = true;
       }
     } catch (error) {
       cartNoteStorageEnabled = false;
     }
     return cartNoteStorageEnabled;
   }
   
   function readCartNoteState(key) {
     if (!key || !cartNoteStorageAvailable()) return null;
     try {
       return window.sessionStorage.getItem(`${CART_NOTE_STORAGE_PREFIX}${key}`);
     } catch (error) {
       return null;
     }
   }
   
   function writeCartNoteState(key, value) {
     if (!key || !cartNoteStorageAvailable()) return;
     try {
       window.sessionStorage.setItem(`${CART_NOTE_STORAGE_PREFIX}${key}`, value);
     } catch (error) {
       // ignore storage failures silently
     }
   }
   
   function initCartNoteCollapsible(root = document) {
     const scope = root && typeof root.querySelectorAll === 'function' ? root : document;
     const containers = scope.querySelectorAll?.('[data-cart-note-collapsible]') || [];
     if (!containers.length) return;
   
     const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches === true;
   
     containers.forEach((container) => {
       if (!container || container.dataset.cartNoteBound) return;
   
       const toggle = container.querySelector('[data-cart-note-toggle]');
       const panel = container.querySelector('[data-cart-note-panel]');
       const textarea = container.querySelector('[data-cart-note-input]');
       if (!toggle || !panel) return;
   
       const storageKey = panel.id || container.getAttribute('id') || '';
       container.dataset.cartNoteBound = '1';
       container.classList.add('cart-note--enhanced');
   
       let transitionHandler = null;
   
       const setExpanded = (expanded) => {
         toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
       };
   
       const setHidden = (hidden) => {
         panel.setAttribute('aria-hidden', hidden ? 'true' : 'false');
       };
   
       const bindTransitionEnd = (callback) => {
         if (transitionHandler) {
           panel.removeEventListener('transitionend', transitionHandler);
           transitionHandler = null;
         }
         transitionHandler = (event) => {
           if (event.propertyName !== 'height') return;
           panel.removeEventListener('transitionend', transitionHandler);
           transitionHandler = null;
           callback();
         };
         panel.addEventListener('transitionend', transitionHandler);
       };
   
       const openPanel = (immediate = false) => {
         setExpanded(true);
         setHidden(false);
         panel.classList.add('is-open');
   
         if (immediate || prefersReducedMotion) {
           panel.style.height = 'auto';
           if (transitionHandler) {
             panel.removeEventListener('transitionend', transitionHandler);
             transitionHandler = null;
           }
           return;
         }
   
         const targetHeight = panel.scrollHeight;
         panel.style.height = '0px';
         panel.offsetHeight; // force reflow
         panel.style.height = `${targetHeight}px`;
   
         bindTransitionEnd(() => {
           panel.style.height = 'auto';
         });
       };
   
       const closePanel = (immediate = false) => {
         if (textarea && document.activeElement === textarea) textarea.blur();
   
         if (transitionHandler) {
           panel.removeEventListener('transitionend', transitionHandler);
           transitionHandler = null;
         }
   
         setExpanded(false);
   
         if (immediate || prefersReducedMotion) {
           panel.classList.remove('is-open');
           panel.style.height = '0px';
           setHidden(true);
           return;
         }
   
         const startHeight = panel.scrollHeight;
         panel.style.height = `${startHeight}px`;
         panel.offsetHeight; // force reflow
         panel.classList.remove('is-open');
         panel.style.height = '0px';
   
         bindTransitionEnd(() => {
           setHidden(true);
         });
       };
   
       const recordState = (isOpen) => {
         if (storageKey) writeCartNoteState(storageKey, isOpen ? 'open' : 'closed');
       };
   
       toggle.addEventListener('click', () => {
         const expanded = toggle.getAttribute('aria-expanded') === 'true';
         if (expanded) {
           closePanel();
           recordState(false);
         } else {
           openPanel();
           recordState(true);
         }
       });
   
       const storedState = storageKey ? readCartNoteState(storageKey) : null;
   
       closePanel(true);
       if (storedState !== 'closed') recordState(false);
     });
   }
   
   document.addEventListener('DOMContentLoaded', () => initCartNoteCollapsible(document));
   document.addEventListener('shopify:section:load', (event) => initCartNoteCollapsible(event.target));
   
   (() => {
     const root = document.getElementById('QuickViewForm') || document.querySelector('form[data-product-form]');
   
     function syncFieldset(fs) {
       if (!fs) return;
       const cur = fs.querySelector('.js-option-current');
       const checked = fs.querySelector('.option-input[type="radio"]:checked');
       if (cur && checked) cur.textContent = checked.value;
     }
     function syncAll(scope) {
       (scope || document).querySelectorAll('fieldset.product-option').forEach(syncFieldset);
     }
   
     // Initial sync (in case radios default-check on render)
     if (document.readyState === 'loading') {
       document.addEventListener('DOMContentLoaded', () => syncAll(root));
     } else {
       syncAll(root);
     }
   
     // Radio changes (click/keyboard)
     document.addEventListener('change', (e) => {
       if (!e.target.matches('.option-input[type="radio"]')) return;
       syncFieldset(e.target.closest('fieldset.product-option'));
     });
   
     // Label clicks (ensure after browser toggles)
     document.addEventListener('click', (e) => {
       const lab = e.target.closest('label.option-chip');
       if (!lab) return;
       const forId = lab.getAttribute('for');
       const inp = forId && document.getElementById(forId);
       if (!inp) return;
       queueMicrotask(() => syncFieldset(inp.closest('fieldset.product-option')));
     });
   
     // MutationObserver: re-sync after any drawer/form re-render or checked flips
     const mo = new MutationObserver((muts) => {
       for (const m of muts) {
         if (m.type === 'attributes' && m.target.matches('.option-input[type="radio"]')) {
           syncFieldset(m.target.closest('fieldset.product-option'));
           return;
         }
         if (m.type === 'childList') {
           // nodes replaced -> resync all within the changed subtree
           syncAll(m.target);
           return;
         }
       }
     });
     if (root) {
       mo.observe(root, {
         subtree: true,
         childList: true,
         attributes: true,
         attributeFilter: ['checked']
       });
     }
   })();
   
   
   
   
   
   // === Quick-View: intercept submit, AJAX add, close quick-view, then open cart drawer ===
   (() => {
     // Allow accelerated checkout to pass through
     const isAccel = (submitter) =>
       !!(submitter && (submitter.classList?.contains('shopify-payment-button__button') || submitter.closest?.('.shopify-payment-button')));
   
     // Resolve selected variant id inside this form
     function resolveVariantId(form) {
       const fieldsets = [...form.querySelectorAll('fieldset.product-option')];
       const opts = fieldsets.map(fs => (fs.querySelector('.option-input:checked') || {}).value || '');
   
       // local <script type="application/json"> that holds variants
       const scope = form.closest('[role="dialog"], .qv, .product, .product__actions') || form;
       let variants = [];
       const jsonEl = scope.querySelector('script[type="application/json"][id*="Variants"]');
       if (jsonEl) {
         try { variants = JSON.parse(jsonEl.textContent || '[]'); } catch { variants = []; }
       }
   
       if (variants.length && opts.length) {
         const hit = variants.find(v => v.options?.every((o, i) => o === opts[i]));
         if (hit) return String(hit.id);
       }
       // fallback to whatever hidden input currently has
       return form.querySelector('input[name="id"]')?.value || '';
     }
   
     async function ajaxAdd(form) {
       // strip any redirect hints
       form.querySelectorAll('input[name="return_to"]').forEach(n => n.remove());
   
       const fd = new FormData(form);
       const vid = resolveVariantId(form);
       if (vid) fd.set('id', vid);
   
       // normalize quantity
       const qty = Math.max(1, parseInt(form.querySelector('input[name="quantity"]')?.value || '1', 10) || 1);
       fd.set('quantity', String(qty));
   
       // temporarily neutralize common redirect hooks
       const prevAdded = window.Shopify?.onItemAdded;
       const prevUpdate = window.Shopify?.onCartUpdate;
       if (window.Shopify) {
         Shopify.onItemAdded = () => { };
         Shopify.onCartUpdate = () => { };
       }
   
        try {
          const res = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
          if (!res.ok) throw new Error('add_failed');
          const lineItem = await res.json();
          window.__SplineCartQuantityState?.refresh?.();
          return lineItem;
       } finally {
         if (window.Shopify) {
           Shopify.onItemAdded = prevAdded;
           Shopify.onCartUpdate = prevUpdate;
         }
       }
     }
   
     // —— drawer helpers
     function closeDrawer() {
       document.querySelector('[data-close-panel]')?.click();
       document.dispatchEvent(new CustomEvent('panel:close', { detail: { source: 'quick-view' } }));
     }
   
     function waitForPanelClose(timeout = 600) {
       return new Promise(resolve => {
         let done = false;
         const finish = () => { if (done) return; done = true; resolve(); };
   
         // custom event path
         const onClosed = () => { document.removeEventListener('panel:closed', onClosed); finish(); };
         document.addEventListener('panel:closed', onClosed, { once: true });
   
         // body class toggle path
         const body = document.documentElement || document.body;
         const mo = new MutationObserver(() => {
           const open =
             body.classList.contains('is-panel-open') ||
             body.classList.contains('side-panel--open') ||
             body.hasAttribute('data-panel-open');
           if (!open) { mo.disconnect(); finish(); }
         });
         mo.observe(body, { attributes: true, attributeFilter: ['class', 'data-panel-open'] });
   
         // timeout fallback
         setTimeout(() => { mo.disconnect(); finish(); }, timeout);
       });
     }
   
     function openCartDrawer() {
       // Prefer programmatic API if present
       if (window.SidePanel?.open) { try { window.SidePanel.open('cart'); } catch (_) { } }
       // Emit common events
       document.dispatchEvent(new CustomEvent('panel:open', { detail: { panel: 'cart' } }));
       document.dispatchEvent(new CustomEvent('side-panel:open', { detail: { panel: 'cart' } }));
       // Declarative trigger fallback
       document.querySelector('[data-open-cart],[data-cart-trigger],[data-drawer-target="cart"],[href="#cart-drawer"]')?.click();
       // Ask cart to refresh
       document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'quick-view' } }));
     }
   
     // Capture-phase submit: block navigations from any other listeners
     function onProductSubmitCapture(e) {
       const form = e.target;
       if (!form.matches('form[data-product-form], form[action*="/cart/add"]')) return;
       if (isAccel(e.submitter)) return; // let Shop Pay/Apple Pay proceed
   
       e.preventDefault();
       e.stopPropagation();
       e.stopImmediatePropagation?.();
   
       const btn = form.querySelector('button[type="submit"]');
       btn && (btn.disabled = true, btn.setAttribute('aria-busy', 'true'));
   
       (async () => {
         try {
           await ajaxAdd(form);
           closeDrawer();
           await waitForPanelClose(500);
           openCartDrawer();
         } catch (err) {
           console.error('Cart add error', err);
         } finally {
           btn && (btn.disabled = false, btn.removeAttribute('aria-busy'));
         }
       })();
     }
   
     // Bubble-phase backstop
     function onProductSubmitBubble(e) {
       const form = e.target;
       if (!form.matches('form[data-product-form], form[action*="/cart/add"]')) return;
       if (isAccel(e.submitter)) return;
       if (!e.defaultPrevented) {
         e.preventDefault();
         e.stopPropagation();
         e.stopImmediatePropagation?.();
       }
     }
   
     // Bind once
     if (!window.__qvInterceptBound) {
       document.addEventListener('submit', onProductSubmitCapture, { capture: true });
       document.addEventListener('submit', onProductSubmitBubble, { capture: false });
       window.__qvInterceptBound = true;
     }
   })();
   
   // ---------------------------------
   // Cart page quantity controls
   // ---------------------------------
   function bindCartPageQuantities(scope = document) {
     if (typeof animateCartShippingBar === 'function') {
       requestAnimationFrame(() => animateCartShippingBar(scope, 0));
     }
     const form = scope.querySelector?.('[data-cart-form]');
     if (!form || form.dataset.cartQtyBound === '1') return;
     form.dataset.cartQtyBound = '1';
   
     const clampValue = (input) => {
       if (!input) return;
       const min = parseInt(input.getAttribute('min') || '0', 10) || 0;
       const value = parseInt(input.value || '0', 10);
       input.value = Number.isNaN(value) ? min : Math.max(min, value);
     };
   
     form.addEventListener('change', (event) => {
       if (!event.target.matches('[data-cart-qty-input]')) return;
       clampValue(event.target);
     });
   
     form.addEventListener('click', (event) => {
       const button = event.target.closest('[data-cart-qty-change]');
       if (!button) return;
       event.preventDefault();
       const targetInput = document.getElementById(button.dataset.cartQtyTarget || '');
       if (!targetInput) return;
       const step = parseInt(button.dataset.cartQtyChange, 10) || 0;
       const min = parseInt(targetInput.getAttribute('min') || '0', 10) || 0;
       const current = parseInt(targetInput.value || '0', 10) || 0;
       const next = Number.isNaN(current) ? min : Math.max(min, current + step);
       targetInput.value = next;
       targetInput.dispatchEvent(new Event('change', { bubbles: true }));
     });
   }
   
   document.addEventListener('shopify:section:load', (e) => {
     const scope = e && e.target && e.target.nodeType === 1 ? e.target : document;
     bindAll(scope);
     // Core (scoped)
     bindCarousels(scope);
     bindFireSearch(scope);
     bindCartPageQuantities(scope);
   
     // Product bits (scoped)
    initShareContainers(scope);
    initComplementaryBlocks(scope);
    initProductGrids(scope);
    initArticleGrids(scope);
     bindHashtagCopy(scope);
     bindProductAccordions(scope);
     bindMobileSwipeMedia(scope);
     initSpCarousels(scope);
   
     // ATC (scoped)
     window.bindAtcIn(scope);
   });
   
   /* ---------------------------------
      Pickup availability
      --------------------------------- */
   if (!customElements.get('pickup-availability')) {
     class PickupAvailabilityElement extends HTMLElement {
       constructor() {
         super();
         this.onClickRefreshList = this.onClickRefreshList.bind(this);
         this.abortController = null;
         this.openButton = null;
         this.retryButton = null;
         this.panelRetryButton = null;
       }
   
       connectedCallback() {
         if (this.__initialized) return;
         this.__initialized = true;
         this.templateEl = this.querySelector('template');
         this.errorTemplate = this.templateEl?.content?.firstElementChild?.cloneNode(true) || null;
         const variantId = this.dataset.variantId;
         if (variantId) {
           this.renderPanel(null, { showLoading: true });
           this.fetchAvailability(variantId);
         } else {
           this.renderUnavailable();
         }
       }
   
       disconnectedCallback() {
         this.detachRetryButton();
         this.detachOpenButton();
         this.detachPanelRetryButton();
         if (this.abortController) {
           this.abortController.abort();
           this.abortController = null;
         }
       }
   
       detachRetryButton() {
         if (this.retryButton) {
           this.retryButton.removeEventListener('click', this.onClickRefreshList);
           this.retryButton = null;
         }
         this.detachPanelRetryButton();
       }
   
       detachPanelRetryButton() {
         if (this.panelRetryButton) {
           this.panelRetryButton.removeEventListener('click', this.onClickRefreshList);
           this.panelRetryButton = null;
         }
       }
   
       detachOpenButton() {
         if (this.openButton && this.openHandler) {
           this.openButton.removeEventListener('click', this.openHandler);
         }
         this.openButton = null;
         this.openHandler = null;
       }
   
       toggleSectionVisibility(shouldShow) {
         const container = this.closest('[data-pickup-section]');
         if (!container) return;
         const inEditor = typeof __inEditor === 'function' && __inEditor();
         if (inEditor) {
           container.hidden = false;
           return;
         }
         container.hidden = !shouldShow;
       }
   
       getFallbackElement() {
         const container = this.closest('[data-pickup-section]');
         if (!container) return null;
         return container.querySelector('[data-pickup-unavailable]');
       }
   
       updateFallbackVisibility(shouldShow) {
         const fallback = this.getFallbackElement();
         if (!fallback) return;
         fallback.hidden = !shouldShow;
       }
   
       getUnavailableText() {
         const container = this.closest('[data-pickup-section]');
         if (!container) return 'Available online only';
         const attr = container.getAttribute('data-pickup-unavailable-text');
         if (attr) return attr;
         const fallback = container.querySelector('[data-pickup-unavailable]');
         if (fallback) return fallback.textContent.trim();
         return 'Available online only';
       }
   
       getPanelContainer() {
         return document.querySelector('[data-panel="pickup"] [data-pickup-content]');
       }
   
       toggleLoading(isLoading) {
         this.classList.toggle('is-loading', Boolean(isLoading));
         if (isLoading) {
           this.renderPanel(null, { showLoading: true });
         }
       }
   
       fetchAvailability(variantId, force = false) {
         if (!variantId) {
           this.renderUnavailable();
           return;
         }
         const normalizedId = String(variantId);
         if (!force && this.currentVariantId === normalizedId) {
           return;
         }
         this.currentVariantId = normalizedId;
         this.dataset.variantId = normalizedId;
         if (this.abortController) {
           this.abortController.abort();
         }
         this.toggleLoading(true);
         const controller = new AbortController();
         this.abortController = controller;
         let rootUrl = this.dataset.rootUrl || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
         if (!rootUrl.endsWith('/')) rootUrl += '/';
         const url = `${rootUrl}variants/${normalizedId}/?section_id=pickup-availability`;
         fetch(url, { signal: controller.signal })
           .then((response) => {
             if (!response.ok) throw new Error(`HTTP ${response.status}`);
             return response.text();
           })
           .then((html) => {
             if (controller.signal.aborted) return;
             const doc = new DOMParser().parseFromString(html, 'text/html');
             const section = doc.querySelector('.shopify-section');
             this.renderPreview(section);
           })
           .catch(() => {
             if (controller.signal.aborted) return;
             this.renderError();
           })
           .finally(() => {
             if (controller.signal.aborted) return;
             this.toggleLoading(false);
             if (this.abortController === controller) {
               this.abortController = null;
             }
           });
       }
   
       onClickRefreshList(event) {
         event.preventDefault();
         this.fetchAvailability(this.dataset.variantId, true);
       }
   
       renderError() {
         this.removeAttribute('available');
         this.detachOpenButton();
         this.innerHTML = '';
         if (this.errorTemplate) {
           const clone = this.errorTemplate.cloneNode(true);
           this.appendChild(clone);
           this.retryButton = this.querySelector('button');
           if (this.retryButton) {
             this.retryButton.addEventListener('click', this.onClickRefreshList);
           }
           this.toggleSectionVisibility(true);
           this.updateFallbackVisibility(false);
           this.renderPanel(null, { showError: true });
         } else {
           this.toggleSectionVisibility(true);
           this.updateFallbackVisibility(true);
           this.renderPanel(null, { showFallback: true });
         }
       }
   
       renderUnavailable() {
         this.removeAttribute('available');
         this.detachRetryButton();
         this.detachOpenButton();
         this.innerHTML = '';
         this.toggleSectionVisibility(true);
         this.updateFallbackVisibility(true);
         this.renderPanel(null, { showFallback: true });
       }
   
       renderPreview(section) {
         this.detachRetryButton();
         this.detachOpenButton();
         const preview = section && section.querySelector('pickup-availability-preview');
         if (!preview) {
           this.renderUnavailable();
           return;
         }
         const panelTemplate = section && section.querySelector('[data-pu-panel]');
         this.innerHTML = preview.outerHTML;
         this.setAttribute('available', '');
         this.toggleSectionVisibility(true);
         this.updateFallbackVisibility(false);
         this.renderPanel(panelTemplate);
   
         const openBtn = this.querySelector('[data-pickup-open]');
         if (openBtn) {
           openBtn.setAttribute('aria-controls', 'global-side-panel');
           openBtn.setAttribute('aria-haspopup', 'dialog');
           if (!openBtn.hasAttribute('aria-expanded')) {
             openBtn.setAttribute('aria-expanded', 'false');
           }
           this.openHandler = (event) => {
             event.preventDefault();
             if (typeof window.openSidePanel === 'function') {
               window.openSidePanel('pickup', openBtn);
             }
           };
           openBtn.addEventListener('click', this.openHandler);
           this.openButton = openBtn;
         }
       }
   
       hydratePanel(panelNode) {
         const productTitle = this.dataset.productTitle || '';
         panelNode.querySelectorAll('[data-pu-product]').forEach((el) => {
           el.textContent = productTitle;
         });
         const hasOnlyDefault = this.dataset.hasOnlyDefaultVariant === 'true' || this.dataset.hasOnlyDefaultVariant === '1';
         if (hasOnlyDefault) {
           const variantLine = panelNode.querySelector('[data-pu-variant-line]');
           if (variantLine) variantLine.remove();
           panelNode.querySelectorAll('[data-pu-variant]').forEach((el) => {
             el.textContent = '';
           });
         }
       }
   
       renderPanel(panelTemplate, state = {}) {
         const container = this.getPanelContainer();
         if (!container) return;
         const loadingText = this.dataset.loadingText || 'Checking store availability…';
         const unavailableText = this.getUnavailableText();
         container.classList.remove('pickup-panel--placeholder');
         this.detachPanelRetryButton();
         container.innerHTML = '';
   
         if (state.showLoading) {
           const loading = document.createElement('p');
           loading.className = 'pickup-panel__loading';
           loading.textContent = loadingText;
           container.appendChild(loading);
           container.scrollTop = 0;
           return;
         }
   
         if (!panelTemplate) {
           if (state.showError && this.errorTemplate) {
             const clone = this.errorTemplate.cloneNode(true);
             const wrapper = document.createElement('div');
             wrapper.className = 'pickup-panel__error';
             wrapper.appendChild(clone);
             container.appendChild(wrapper);
             const retry = container.querySelector('button');
             if (retry) {
               retry.addEventListener('click', this.onClickRefreshList);
               this.panelRetryButton = retry;
             }
           } else {
             const message = state.message || unavailableText;
             const fallback = document.createElement('p');
             fallback.className = 'pickup-panel__empty';
             fallback.textContent = message;
             container.appendChild(fallback);
           }
           container.scrollTop = 0;
           return;
         }
   
         const node = panelTemplate.cloneNode(true);
         this.hydratePanel(node);
         container.appendChild(node);
         container.scrollTop = 0;
       }
     }
   
     customElements.define('pickup-availability', PickupAvailabilityElement);
   }
   
   window.updatePickupAvailability = function updatePickupAvailability(newVariantId, productId) {
     if (!newVariantId) return;
     const desiredProductId = productId ? String(productId) : null;
     document.querySelectorAll('pickup-availability').forEach((el) => {
       const elementProductId = el.dataset.productId ? String(el.dataset.productId) : null;
       if (desiredProductId && elementProductId && desiredProductId !== elementProductId) return;
       el.fetchAvailability(newVariantId);
     });
   };
   
   document.addEventListener('variant:change', (event) => {
     const detail = event.detail || {};
     const variant = detail.variant;
     if (!variant) return;
     const productId = detail.product?.id || variant.product_id;
     if (typeof window.updatePickupAvailability === 'function') {
       window.updatePickupAvailability(variant.id, productId);
     }
   });
   
   const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
   
   document.addEventListener('variant:change', (event) => {
     const detail = event.detail || {};
     const variant = detail.variant;
     if (!variant || !variant.featured_media) return;
     const mediaId = String(variant.featured_media.id);
     const productId = detail.product?.id || variant.product_id;
     if (!mediaId || !productId) return;
     const productIdStr = String(productId);
   
     document
       .querySelectorAll(`[data-product-gallery][data-product-id="${productIdStr}"]`)
       .forEach((gallery) => {
         if (typeof gallery.__pgcSetMediaById === 'function') {
           gallery.__pgcSetMediaById(mediaId);
         }
       });
   
     document
       .querySelectorAll(`[data-alt-media][data-product-id="${productIdStr}"]`)
       .forEach((alt) => {
         const items = alt.querySelectorAll('[data-media-id]');
         let targetEl = null;
         items.forEach((item) => {
           const isActive = item.dataset.mediaId === mediaId;
           item.classList.toggle('is-active-media', isActive);
           if (isActive) targetEl = item;
         });
         if (targetEl) {
           const scroller = targetEl.closest('[data-alt-media]');
           if (scroller && scroller.scrollWidth > scroller.clientWidth + 1) {
             const behavior = prefersReducedMotion ? 'auto' : 'smooth';
             const scrollerRect = scroller.getBoundingClientRect();
             const targetRect = targetEl.getBoundingClientRect();
             const delta =
               targetRect.left -
               scrollerRect.left -
               (scrollerRect.width - targetRect.width) / 2;
             if (typeof scroller.scrollBy === 'function') {
               scroller.scrollBy({ left: delta, behavior });
             } else {
               scroller.scrollLeft += delta;
             }
           }
         }
       });
   });
   
   document.addEventListener('DOMContentLoaded', () => {
     bindCartPageQuantities(document);
   });
   
